var _style, _path, _feBlend, _feBlend2, _mask, _feBlend3, _feBlend4, _mask2, _feBlend5, _feBlend6, _mask3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDhoorbinchoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000000908300930954273200000001826390618787645607_);}\r\n\t.st2{fill:url(#SVGID_00000174587060917262106700000000780919164728259514_);}\r\n\t.st3{fill:url(#SVGID_00000083087852463608292500000008920989517368164532_);}\r\n\t.st4{fill:url(#SVGID_00000070085978633377410120000006513212419937304971_);}\r\n\t.st5{fill:url(#SVGID_00000137103243157242066020000015043532734387993488_);}\r\n\t.st6{fill:url(#SVGID_00000060027351085039443550000003958587723697017007_);}\r\n\t.st7{fill:url(#SVGID_00000160906352292745453810000012084217208353091989_);}\r\n\t.st8{fill:url(#SVGID_00000098205051136414976050000002182223166706867590_);}\r\n\t.st9{fill:url(#SVGID_00000157276283160371512970000008825280837280567693_);}\r\n\t.st10{fill:url(#SVGID_00000173851154114635365500000004760741136704731534_);}\r\n\t.st11{fill:url(#SVGID_00000071549771794209142440000014837359275969022604_);}\r\n\t.st12{fill:url(#SVGID_00000150093794042767110700000009931960112941372299_);}\r\n\t.st13{fill:url(#SVGID_00000079473132340927430000000001894681196043471000_);}\r\n\t.st14{fill:url(#SVGID_00000150099900663501231360000011879879475190386579_);}\r\n\t.st15{fill:url(#SVGID_00000077298054001497090090000008666079935093812916_);}\r\n\t.st16{fill:url(#SVGID_00000125597757422325920130000015866432300695013553_);}\r\n\t.st17{fill:url(#SVGID_00000112627980414384081310000004425576220656799640_);}\r\n\t.st18{fill:url(#SVGID_00000177471041377825188470000007561686421356427945_);}\r\n\t.st19{fill:#C4C4C4;}\r\n\t.st20{fill:url(#SVGID_00000155143320173597741660000018173259885191287193_);}\r\n\t.st21{fill:url(#SVGID_00000168115287361036960640000006687240985990194864_);}\r\n\t.st22{fill:url(#SVGID_00000138559421461045889580000003903164686367853229_);}\r\n\t.st23{fill:url(#SVGID_00000006697659565745289730000001845845794738584210_);}\r\n\t.st24{fill:url(#SVGID_00000173880026977888941880000013489663380664240277_);}\r\n\t.st25{fill:url(#SVGID_00000114751734779433788670000009407049752186939526_);}\r\n\t.st26{fill:url(#SVGID_00000026141642600368186630000011484223109175798688_);}\r\n\t.st27{fill:url(#SVGID_00000083778757884498544400000007495823377873067433_);}\r\n\t.st28{fill:url(#SVGID_00000102515265459131619620000016650838186765579920_);}\r\n\t.st29{fill:url(#SVGID_00000134223181953684062370000014768853329466040980_);}\r\n\t.st30{fill:url(#SVGID_00000131337214752804215740000017573136799371600513_);}\r\n\t.st31{fill:url(#SVGID_00000163053328881015918160000007162377662901853621_);}\r\n\t.st32{fill:url(#SVGID_00000155114704595578416230000010653711393112607886_);}\r\n\t.st33{fill:url(#SVGID_00000134954590293260339900000016382797568095484806_);}\r\n\t.st34{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st35{filter:url(#Adobe_OpacityMaskFilter_00000111902966499767325990000011542568583530503557_);}\r\n\t\r\n\t\t.st36{mask:url(#SVGID_00000124133528556019584860000017129810259028948114_);fill:url(#SVGID_00000168818348642092195750000005387824045162718904_);}\r\n\t.st37{opacity:0.7;fill:url(#SVGID_00000048491711610450264500000007374756623119400079_);}\r\n\t.st38{fill:url(#SVGID_00000173857352270485729280000009819164756930065809_);}\r\n\t.st39{filter:url(#Adobe_OpacityMaskFilter_00000074410351766150285100000007002575361790936220_);}\r\n\t.st40{filter:url(#Adobe_OpacityMaskFilter_00000054235286430168631370000015561618210613662905_);}\r\n\t\r\n\t\t.st41{mask:url(#SVGID_00000114069081336769674820000012208279092001873073_);fill:url(#SVGID_00000052798205239831176250000016278024291791538591_);}\r\n\t.st42{fill:url(#SVGID_00000010303829688085531190000018392562378248359817_);}\r\n\t.st43{fill:url(#SVGID_00000160886896299885334630000007590747736294608052_);}\r\n\t.st44{fill:url(#SVGID_00000152975943770665433250000017627098130431763127_);}\r\n\t.st45{fill:url(#SVGID_00000055700335928253381860000000381196626744564610_);}\r\n\t.st46{fill:url(#SVGID_00000039841373749914351720000012425902771387363241_);}\r\n\t.st47{fill:url(#SVGID_00000057833398121854427410000005046113011474673578_);}\r\n\t.st48{fill:url(#SVGID_00000168092741469551555910000012919460313089248671_);}\r\n\t.st49{fill:url(#SVGID_00000023276084859692249600000016821820240930031280_);}\r\n\t.st50{fill:url(#SVGID_00000129912175062362860030000017117600308666983832_);}\r\n\t.st51{fill:url(#SVGID_00000099627825992807634870000008849853703761625526_);}\r\n\t.st52{fill:url(#SVGID_00000026151226817215541030000006980650002247250366_);}\r\n\t.st53{fill:url(#SVGID_00000036223802238684304990000014526024195262689960_);}\r\n\t.st54{fill:url(#SVGID_00000173853303179093173320000001059170828433938816_);}\r\n\t.st55{fill:url(#SVGID_00000146478816814786956280000000283696057204581273_);}\r\n\t.st56{fill:url(#SVGID_00000096040949508083792710000017390735986418518180_);}\r\n\t.st57{fill:url(#SVGID_00000103955673239990324530000016989184700326873478_);}\r\n\t.st58{fill:url(#SVGID_00000080912947528392651960000017362136400272111248_);}\r\n\t.st59{fill:url(#SVGID_00000114777688451788464140000018002153205576572831_);}\r\n\t.st60{fill:url(#SVGID_00000108276329949912738810000016042535139871547056_);}\r\n\t.st61{fill:url(#SVGID_00000029013960834241550650000017542226952679583397_);}\r\n\t.st62{fill:url(#SVGID_00000066509792836479611070000015561746266105010067_);}\r\n\t.st63{fill:url(#SVGID_00000024705019087407054720000017564703429108750234_);}\r\n\t.st64{fill:url(#SVGID_00000152251051956807752540000007755292213662748569_);}\r\n\t.st65{fill:url(#SVGID_00000175283264861156702420000007173258391554029246_);}\r\n\t.st66{fill:url(#SVGID_00000034807600531928955420000008051473664508332702_);}\r\n\t.st67{fill:url(#SVGID_00000008114366477223163100000006457185128406179460_);}\r\n\t.st68{fill:url(#SVGID_00000147915665870182134120000003841326353002516159_);}\r\n\t.st69{fill:url(#SVGID_00000097484448012801829020000018264022421512604288_);}\r\n\t.st70{fill:url(#SVGID_00000090274607119506683080000000549910933690953616_);}\r\n\t.st71{fill:url(#SVGID_00000010277976367616224250000017540670788405822905_);}\r\n\t.st72{fill:url(#SVGID_00000109007734198815918650000018347828195689652365_);}\r\n\t.st73{fill:url(#SVGID_00000176031965692334460710000003283257606531511219_);}\r\n\t.st74{fill:url(#SVGID_00000094620059925287316720000016867341701310278536_);}\r\n\t.st75{fill:url(#SVGID_00000173139279741414394550000001733198660760605315_);}\r\n\t.st76{fill:url(#SVGID_00000178883285404084161950000001826979467962995379_);}\r\n\t.st77{fill:url(#SVGID_00000170252497353417723470000017253611053089129653_);}\r\n\t.st78{fill:url(#SVGID_00000062164223056783809200000015596931394163191472_);}\r\n\t.st79{fill:url(#SVGID_00000181075940543832137670000011338859304541307804_);}\r\n\t.st80{fill:url(#SVGID_00000153664164953780714800000016702346142424950198_);}\r\n\t.st81{fill:url(#SVGID_00000065074426094871732840000003895809665847694472_);}\r\n\t.st82{fill:url(#SVGID_00000159446153117087910360000006396477181674801327_);}\r\n\t.st83{fill:url(#SVGID_00000015317043365113077890000014872307222139988610_);}\r\n\t.st84{fill:url(#SVGID_00000177452233066222669220000012500032458416033970_);}\r\n\t.st85{fill:url(#SVGID_00000021101206311632123640000015244050347422200765_);}\r\n\t.st86{fill:url(#SVGID_00000086690827210525437480000010296823084748197764_);}\r\n\t.st87{fill:url(#SVGID_00000130629132932661190480000006484751109954568895_);}\r\n\t.st88{fill:url(#SVGID_00000099627399391690967990000017575268326214515617_);}\r\n\t.st89{fill:url(#SVGID_00000067208004542871927880000007012163929210313348_);}\r\n\t.st90{fill:url(#SVGID_00000052788669278373175850000002014139343294308524_);}\r\n\t.st91{fill:url(#SVGID_00000047767220543510866360000015121402407611812541_);}\r\n\t.st92{fill:url(#SVGID_00000162319569787200374790000013012871545879870142_);}\r\n\t.st93{fill:url(#SVGID_00000063631436013220544250000005740728638983264387_);}\r\n\t.st94{fill:url(#SVGID_00000057111971916901043370000012348945633325156746_);}\r\n\t.st95{fill:url(#SVGID_00000131364544942023746070000001138594004862361763_);}\r\n\t.st96{fill:url(#SVGID_00000114776645795962174610000009856698841488993192_);}\r\n\t.st97{fill:url(#SVGID_00000101098522580941140140000017530415728299416980_);}\r\n\t.st98{fill:url(#SVGID_00000159440945350578751950000011734470045197636271_);}\r\n\t.st99{fill:url(#SVGID_00000013166441408544178920000006481556117757065641_);}\r\n\t.st100{fill:url(#SVGID_00000000213554418755678770000004512554236763693698_);}\r\n\t.st101{fill:url(#SVGID_00000107563519180439002740000001799974800623430311_);}\r\n\t.st102{fill:url(#SVGID_00000167355181213209168810000003864495530903086511_);}\r\n\t.st103{fill:url(#SVGID_00000099625106359926686310000005392920653680250268_);}\r\n\t.st104{fill:url(#SVGID_00000061433458277559472570000003912843056856148362_);}\r\n\t.st105{fill:url(#SVGID_00000050647782833075170460000004213332346379268502_);}\r\n\t.st106{fill:url(#SVGID_00000007420228200510606380000004693539662597825159_);}\r\n\t.st107{fill:url(#SVGID_00000010312892886750050840000001961917464568810372_);}\r\n\t.st108{fill:url(#SVGID_00000098928678650566696680000006639812823795355579_);}\r\n\t.st109{fill:url(#SVGID_00000065062691222530537400000017335158361682475185_);}\r\n\t.st110{fill:url(#SVGID_00000132078803954581448100000006575741023513041583_);}\r\n\t.st111{fill:url(#SVGID_00000154417905488079564740000011348328397026562978_);}\r\n\t.st112{fill:url(#SVGID_00000044135395246203280000000004719939158232405143_);}\r\n\t.st113{fill:url(#SVGID_00000152973133233904086010000005278697687689837730_);}\r\n\t.st114{fill:url(#SVGID_00000021109916038143290180000002044139960230082703_);}\r\n\t.st115{fill:url(#SVGID_00000083771987861676282330000011788854871816649892_);}\r\n\t.st116{fill:url(#SVGID_00000082358591101694649960000015669300901686542266_);}\r\n\t.st117{fill:url(#SVGID_00000091708400458969834430000016448168991530198434_);}\r\n\t.st118{fill:url(#SVGID_00000070820648332474212770000001540121124748277393_);}\r\n\t.st119{fill:url(#SVGID_00000014594939387778133940000013524395598215394480_);}\r\n\t.st120{fill:url(#SVGID_00000008109834454933979010000014581556990562853567_);}\r\n\t.st121{fill:url(#SVGID_00000134929533321899908150000008855944748604872348_);}\r\n\t.st122{fill:url(#SVGID_00000170244120340334532640000015875239495252346783_);}\r\n\t.st123{fill:url(#SVGID_00000132054824630465239950000006510420265751145088_);}\r\n\t.st124{fill:url(#SVGID_00000088853370912887811200000010536432824022269611_);}\r\n\t.st125{fill:url(#SVGID_00000031189084366321694230000009226911701026381224_);}\r\n\t.st126{fill:url(#SVGID_00000031924135808356623710000015425320963731292317_);}\r\n\t.st127{fill:url(#SVGID_00000023245233945910036370000017359376864307730340_);}\r\n\t.st128{fill:url(#SVGID_00000155104782541992704500000010501415176171343291_);}\r\n\t.st129{fill:url(#SVGID_00000132808494192257634540000008678662132663074239_);}\r\n\t.st130{fill:url(#SVGID_00000062182448787201267930000013930788712501063054_);}\r\n\t.st131{fill:url(#SVGID_00000147207090592108049220000004393421744223032746_);}\r\n\t.st132{fill:url(#SVGID_00000054959329791184587370000015777871771761792133_);}\r\n\t.st133{fill:url(#SVGID_00000000937506318183074620000016606174614228516254_);}\r\n\t.st134{fill:url(#SVGID_00000096752947518101827700000006353255136829038258_);}\r\n\t.st135{fill:url(#SVGID_00000122690354519212099340000002107695856285503876_);}\r\n\t.st136{fill:url(#SVGID_00000066489026317387247530000002909478535491968696_);}\r\n\t.st137{fill:url(#SVGID_00000060710364261705947160000004984636196563586215_);}\r\n\t.st138{fill:url(#SVGID_00000108991986267890180650000000645980566035486135_);}\r\n\t.st139{fill:url(#SVGID_00000168082677464722187930000007155786097008268217_);}\r\n\t.st140{filter:url(#Adobe_OpacityMaskFilter_00000103984403977847225640000004458481285277253567_);}\r\n\t.st141{filter:url(#Adobe_OpacityMaskFilter_00000171716386967617219420000013724330764246265751_);}\r\n\t\r\n\t\t.st142{mask:url(#SVGID_00000061439131874748818090000016537672189659865505_);fill:url(#SVGID_00000041994269874026500200000015548125342523126927_);}\r\n\t.st143{opacity:0.7;fill:url(#SVGID_00000172419322861051737010000000490756813877691063_);}\r\n\t.st144{fill:url(#SVGID_00000082353460512078027600000004288275747357217950_);}\r\n\t.st145{fill:url(#SVGID_00000007412133433570260060000003744668863721883833_);}\r\n\t.st146{fill:url(#SVGID_00000011024531125928365450000009636001228095860131_);}\r\n\t.st147{fill:url(#SVGID_00000024698914409364291980000007616227540162065083_);}\r\n\t.st148{fill:url(#SVGID_00000019654762784990872280000005796872236020637600_);}\r\n\t.st149{fill:#FFFFFF;}\r\n\t.st150{fill:url(#SVGID_00000157993952551090897810000009929971149536113045_);}\r\n\t.st151{fill:url(#SVGID_00000116946650461272072230000011547772018615600826_);}\r\n\t.st152{fill:url(#SVGID_00000008110093527206175960000010386204014164003736_);}\r\n\t.st153{fill:url(#SVGID_00000158724759837642703900000009811802914675709362_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.4832,
    y1: 256,
    x2: 463.5168,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1828,
    style: {
      stopColor: "#007788"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2276,
    style: {
      stopColor: "#006C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3266,
    style: {
      stopColor: "#005A69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#00505D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#004C59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#00515E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7523,
    style: {
      stopColor: "#005F6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#007586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8959,
    style: {
      stopColor: "#007788"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.52,364.38V147.62c0-7.07-3.77-13.61-9.9-17.15L265.9,22.1c-6.13-3.54-13.67-3.54-19.8,0L58.38,130.47 c-6.13,3.54-9.9,10.07-9.9,17.15v216.75c0,7.07,3.77,13.61,9.9,17.15L246.1,489.9c6.13,3.54,13.67,3.54,19.8,0l187.72-108.38 C459.74,377.99,463.52,371.45,463.52,364.38z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 905,
    height: 732,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA4sAAALdCAYAAACFs/Y9AAAACXBIWXMAABFgAAARYAFbISxkAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAYm9JREFUeNrs3WmsZOt6H/Sn6vTp Pufc6XiebWzHs2Nsx3FsY8czIY7J7Agl+QLf4BsS4gPwESRQGCICIiKKiBQEKBIQO3ZyY1/HjmNZ isCSSQwoKEQJSTzdwecO557uPt1VrOquql711jutVbV7D/X7SfvW3jXtfXbXrbX++3ne540AAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAJjnrbfeWmw+/CYAAM7nnl8BcItD4nL76dpvAwBAWASExHvbgCgkAgBckaVfAXCbfPzjH3/V bwEAQFgE2IXE+4IiwDFrtoGrog0VuOkh8bXQcgrQExgXb7755spvAzgXlUXgpobE5TYoAlAxBMT1 KDQ6twPORmURuGkh8ZXh4kGoJgLMMgTGzfvopsr4xG8DEBaBuxISXxcSAc5ivVvn/YEPfOBdvw5A WARunU984hObkPjGenDK84zbsAAY0uJgMdgMCBu+XAyh8ZHfCjCFvnbgOoPi5g9W7/GbALh61oED U6ksAtcVEt8b81tOVREB8u+Ni9r75jYwbqqM7/h1AcIicJNC4mb9zPtOCIlxarsqwIWHxtiGxje2 ofFtvy6gxCauwMsKie8fBcR1+jEKgeltkblfer01i8DF2+21ODrH2yxZPLou87EZgvMpv0EgZc0i 8DKC4gdOeIpSFVI4BOh/H62+vw7v1e/zawJS2lCBK/HJT35yM33vzaQSeCVUFQFOTJPDW/UQGDcd IIv3v//9H/cbAYRF4KpC4mfG+YfXCIQAfe+hixcZcB3bVtTuxw+h8c1taPxtv064bNpQgXMHxc86 8SRnyn0ESIDp76frntuH0PiZfo1w2Qy4Ac4REh8MF58d5cE1xYE1lfus0vsabgNQ1zHkZjm+bfwx qkAe3fb+97//o367cHm0oQKnhsTPifkVvp6W0+pwG0ERoPv9dhHlbTWq22184hOf+OxtaPywXyUI iwBFn/rUpzabOn/uCcNreh8nCALMD4bNEDglMG588pOf/NzNfd73vvf9pl8z3H3WLAJzguLnnXgS MzU4rjOPFSQBEkm3xbPPR/vYlt5fp76frofQ+Pl+23D3qSwCU0LiF8T8KadzguSLG16c7GhBBTjt fXYxei9djN5nY8Lg1F1gXL7vfe/7Nb9WEBaBywyJrw8XX3jFIXEcAtMhNgDMD4WloLiY8Nja/Teh 8Ys2nwyh8Z/7tcPdYhoqUAuJXxyZCaeRn2Iaye3PpplmJp22JqHmPjZ3TKejqiwCFDSmopY+NndK p6Uuk+coTlPdfQyh8Z/6F4C7wZpFIBcU3xguvmTmw3MVyPS6SdVDLagAV6Kno2NdeD+uHUO+1K8W 7gZtqMDe22+/vQmJXxovKn4nhcTMtNTc16UTFWEQ4PQwuKiEv6OW1InrFvPfdHiOITB+2eZ53/ve 9/5j/wxwe2lDBTYh8T3DxZfFxPbQU1tM57agqioCtM1sRd3dZ2NZub3nOfYfQ2j8R/5F4PZRWQQh 8cvj6ofXpLq/V64FFYCzvh8vIj8ltfT5+HFdPvWpT33lNjT+Q79yuD2sWYTLDopfMfvsot6lWlrz so6+1tP1qSET4NJtuzBqrf9z3ntbSwvWjdD4Vf5l4PZQWYQL8+lPf/q9w8VXZtYTzs6NnScOrZOQ o8vMtFWDbQDmv1cvNu+ri8aixNa6xcxz5KqO46/TwPjVm8e/5z3v+Qf+WUBYBG5OSPyqOF/Laekv 1vuTidbJCAAvLyhWri+1okYmBC4mft9iaHz77be/dnPbEBr/b/9EcDNpQ4XLCIrvGy6++ownHdXR 6pXb1hM+jh6rqggwTfK+mQ4Xi+hrRW0tITh+wOEfBKt/pBxC49f7l4KbSWUR7n5I/Jo4TzWx9zla 6xO7qooG2wCc1aSq4IRW1CmDb0qVxvU2MC7f8573/Kp/Krg5bJ0BdzMkvn+4+No4z7YWq8Ztkd6v 8tyr7UnG7nGly6PnUFUEmC/dRmOwHJ0L9mx/sRw9fhkdW2hsv0fPbenPsQmNf8+/Glw/lUW4Q955 551NSPz6mcNrcq2ltaE068775e5fvcwNtgHgfGYMuqltqTG1krj7/lF47KbS+C9ufr433njjV/xr wfWxZhHuVlD8hjnnDNE/nKYV4JprWmYMthEYAU7UuY3GpC01kuUC61zY7Dh2VN/jP/3pT3+Lfz24 PiqLcPtD4geGi2+M6ZW40qCa6nCD5OCfu732+OaH7TIArlzPNhrpfXqqiaUpquntk5ZBDYHxWzeP eeONN37ZPx0Ii0B/SPymGSFxSnWvFShb4XLyYJvGiQcAM23+8PbWW2+Nw1q6VUZpG43a9hqLSgic en0rNH7bNjT+b/41QVgE8iHxzeHim+NwwMy5Tak67m+rrJVUVQS4WXLVxakBMff49PbNusdsOEzW LeamqmYD5RAav30bGv+uf0a4WtYswi3y8OHDN4cD6znWb6wLIXCdaSOttaDWwmHpsd0/o6AIcF4d axfT63Lv36316aVjROuYUXpM1jvvvPMd/kXhaqkswu0IiZ8xXHxrnD4htHYQ7qkkTjkxWBdu664q AnClequLqVyFcEo7ak8b6vjHKt5/CIzfubn+9ddf/yX/nHB+9lmEmx8Svy0m7IEY+X0OV8ntq0po y922aj1vZu/Fnn0Xiz+zqiLA1Wnsu7j7fHxZ21dx2dhzcVnYszHdczGS20rPW/x5htD4i/514XxU FuFmhsTP3IbEiPNWEqvtRB0tqK3R6qqKALfHfqrpidXFdbIn49TK4tQ9HGuVxu/ZhMkhNP5t/7xw OmsW4WYGxW+P0yv/rT2tinshRt86k9x2GevKbd0/t6oiwNVK3mdrXSAR+bWL2anXpeNL8gfH2rGl 5/ljdHzJroEcQuP3+leG06kswg3x6NGjzxoufk/kK3z9Sat/Imnt4Hxwf1VFgLsZGJOtNErHhbnV xdwU1Ui/zkxFXYyeNFrrFku3PXz48Ps217322ms/518bhEW4zSHxO2cEpt6tLUoTSXOhLfc8V1FV LA7ZUVUEuBbrJJzllLbKyIbHqaEx6vs+VoNhIzT+wHCxHELjh/wzwzTaUOH6g+J3zTig944iX5fC Ye/9T6gq1j6iEVABeAkyW2k0A2XlWJLrFul5zy911PS2upZ+zoPrhtD4Q/7FYRqVRbiekPjZw8V3 x+H00CsNiaPQF5UDeC789VYV11HfV7HZfqqqCHCteqqLu9sXhWPElOriOnlc9rlqrahJC2vu5zy4 bgiMPxzPW1N/2j83tNk6A16ix48fb0Li9yTVulUjSK2ib9uMVeNxq8b3W0V+q4zSVhqR2Waje7sM W2UA3BwdW2kcbVPR2A5jUXrsaKuM2jYaua030tuWjZ9j2dru48GDB3/Dvz6UqSzCywmJnzNc/N7t l70tP70tNuvOr1stQ+lje6qK2eeuVBwNtQG4gdJhN421ialiVTD6q4u1dZC7H6e15jEaz33k0aNH P7K5fQiNP+VVAMesWYSXExS/L85TyS+GucwU1J7BNsXnra1VLExcLa1TKQXc/eeqigA3ytStNHK3 TV27mA5b6z1mReWYlL1/ITT+qH92OKYNFa4uJH7ucPH90a6sdbeFRrtltNSemm0lrfwcq45W2FwL ahS+l/ZTgFtg1I76fCFgvi20txV1V5SotY8e3dbZVrrseEyuTfXgsbn/vgcPHvyEVwI8pw0VriYk /mDMbLOstIVGMqSmq/20UVXMfp2pKkaUW0hrW2VoPwW4ffbtm6MBMqVjVpTaVUetrLVW06MhN5Xn XEehvbXwmFIbaul5nnn06NEf2obGv+qlwKVTWYQzeffddz9vuPihUXAqVtg6htTUKoG1wTZzqoq1 wTYR5UE5c4barMYhUlUR4OZJh93E8cCaiPJAm9Kwm9rgmp7BNMtoDLuZWHVsfZ/9f9P9+/f/F68K LpU1i3C+oPjDo4NNS+82GBH5CmH6mFZVsbTmpFQdzA6oKQyuiYjuoTaCIsAN19h7sbWfbnRc1zqO 9axd7Nm7t9ZhE1HefurA48eP/5hXBZdKGyqcFhI/f7j4ffGiCtcKQD0hsdVm2nNw3H29ignDBWrD DCrtp+nzHf03aD8FuJUOlkFU2lEXmZbT9Lb915nnLU0wLU1GLT1fqeU1bXXd/7fV9mlMAuOPxfMq 41/xsuCSaEOF+SHx90e75bLVrpkbKtPTZroqfJ/c9bU20nMMtdF+CnAHndiOmttfsbVX4jKmDcHJ 7tdY2MexOASnczjOwc8whMb/ySsEYRE48OTJky8YLn6kFY5qYXHCpNNW8GutO5wzTbUVBleVILgK 008B7mpgzK1NrE1HnTLlNA2F1Wml29t71iguGwFzHAp7rj/6mV999dX/wauEu8yaRZgWFP9AbI8Q Ex/e3PQ+E9Zy94+Ytu6wtBdV98eM9lPTTwHuiNH6xZ5BZtX167XHFvb2XReOZ7llFj1LLSLySzyi cqyqzQfYdBr9Ka8S7jJrFqEdEr9wuPjRKI/6PjqwVDYcjsaBKArBbxX9C/lrQwZqoa+5DUfn80bh 96SqCHC77Y5LkVkzuL/MrCkcHw8WyTFjUQlwtW0xdt+ndGwuBcLx90x//qP7vliKWd5uYwiMf3rz +auvvvqXvUS4a7ShQj0k/sHtl6tMwKqtSWy1oJbWEdbaTJvrFON4q4x9i+gVtZ/2ViQFRYBbLGlH jUJ76DnaUXvWIba20qitg5zSppp7nubPNITGv+QVw12hDRXyQfGLhos/HIcL+2vWjdtK1beeal2x 1SbyU0ePbuusNmo/BSAraUeNjsFmc9tRW9d3H8cmHGer234UWmSze1ptvPvuu/+6Vwx3hTZUGHn6 9OkmJP6RyO/x1KO4lcXoYLOKcpvpOPhNOsieuB4xor/VNHe/apBVVQS4U3LtqDuldtTxbePHlraP Gn8+bkcdt7zuDqOL3PYbyfff3b7ptFkm23ykW3Lktt1YFH7ObGvrEBj/jc33uHfv3l/0cuE204YK z0PiFw8XfzQJcaU2yzlbWfS0lNa20ei5/9T209bWHrnbQ/spwOVKt9PYtmLuzilL22X0tJymLZ6T Wj+j3ka6PPH+uW00lh3/DfvPh9D4F7x6EBbhdobEPx75ls7eNYm1IFdbqzglEFa33ejYU3HKlhtH gTPq+0MKigCXGRh7t9PI7skY9fWLPWsLoxL+evdd7FnTmK5drK11rAbbITT+ea8gbhNrFrn0oPhj yRt5ybpxfc+6h9b6iYgZbaZz2k9bP0PUJ6ZapwhwwWZsp7EqHV/OuX7xxOPn7rlWlfvv7xPlpRjV NY1Pnjz5N72CuE2sWeTirFarLxku/kRmSEuP0kEnKmsVzxHyItoDcE4Nl7mfdRXTBwc8+1xVEeAi zFm/uDm2LKO+ncbuPulxunTsTtcprpNjdyTrFNOfK/0eR/ct/bybMDyqIuYee/C7GALjv7X5WV55 5ZX/2suHm04bKpcWEv+1cbCpBKc5LaJH1xeeo/Xcre0tavevrqns2CbDOkUAulzh+sWe24otrNv7 n7p2sdaOusw8R/a5S993fN0QGv+cVxPCIlxfSPzSUUjcBcWI+n6ItSE1U0NhaahNaf1ia31h756N tZ9lyjrFo+sERQCSwHiV+y/2rCNMn6sVMJeF+y8bz1PcezF5jtzaxdL1z24bQuOf9YriprFmkUsI in9y9OZc+yPJunBdbZuInn2kVjGz/bTRSrpqPH5VuK7286dBcXxddPx8AFyQl7T/4qq0TOJc6/xP WP8fhf+2Vev69Lj59OnTf9sriptGZZG7HBL/VCX4FVtKK5W59Ppc++mc6afn2CYjFyJL01un3JYL mrkD9LPfr6oiwGWaMCF1Ge2W1LRqt9G71cXs7TEK1ctT21GL9608x2K5XP5nXlXcBAbccFdD4ngd Ra7qVfsLYXSEprlVwlWc/6+f0Xj+3jDY831Wmd+hoAjA+NjQGniT3r4u3S9Gw3C2jzkafDMaMJM+ XzpIZ3zb0TF/eJ5lMuymdP2z5x0Nxxn/jOOfJTcEZ134OfaDcTb/ncP5zL+z+XoIjX/GS4rrpA2V uxQUv2y4+NOx/cveYisOK+jV6aWtQS5x5laWRqtqT/Cb/bNMnIqaC6YhKAKwMWpHjejbLmrO8al3 O43VzONpaduM1QlLSKp/eC60qO5D5HBu8+96dXGdtKFyF0Lil25DYjYcZlpCp7aUHl0Xx0NqihNR G9eXnjfXejppoE3lILky0AaAq3BFA296busdeJMbnDN3Emr6PVtDc3rbVLMtqsvl8j/2CkNYhGkh 8U8WDhDFQJeExd7rzrFOsbl+sRH8ciGyJ1xG5Kei1v7qmQ2MgiIAEwNjbf1ibipoaW1jKTD2rmHs DZjV9Y4T1x52B8M43PKjdt2QGZf/kVcZL4s2VO5iUIyoTAbNtX42rmsNhGlV8FrXr6IxybTSftpq o0kDX+53k/vvbQVFAMhKJqS2lmdEaS1+9C3tOKXFdFU73kd9onnzD7qdx+5V9E8zXz8/BVr9+15l vCwqi9y2kPgl8XzPxIO/siXtp3NaR5vXFUJeq520dPDI7XU4ZW/HuZNPs/ssVg7IJp8CMNm2urg7 1yxVGPeTTqMyIXU0MGaZuW3ShNRSZTAqk0mj3Kbaal+tVRKXlb0am9ftHj/4D73auEoqi9zWoDg+ +EQcbyuximlrDJt/3esMbaVAWA1yjcXwR5XBEyafThmQY/IpALMkx4nSsWbVuD1dS999bJvQkVOt 4s3sHJryx+Dc+UD3H7AH/4FXG1dJZZEb7+nTp5uQ+CdKaw2Su9daR2stI7n7tqqB6aCYycNsCgec 2hrFVaUFptg+U5i6utomz+oE2PQgLSgC0Gu0fnF33llbh1jbf3HZ2JtxGeV9Flv7L9aqi6X1h6Xn KQ69qVQIW5XLZlV088u1lpGroLLITQ+KXzxc/Ni2epjbBiMNfEcfQ9h5mlx3ZUEx6mscVpXg1xPu pm61UX2uzqC4FhQBmKuypUbEhL2Ho1CJi3lr+Fcd21ukx+tV58+0Kn3dMXQvPcc4+iN3cp5ycH4z +Pe84jg3lUVufFCM478MLgqv3a4F5B1rCWcHxdz9C+2rPRXCri0yKmHQFhkA3Ai3YEuNUkWyVd1r VQdPqTC2Jqdmz4tssYGwyKUExT8e+QE2uQpjRLsCt+rY1/AqguKcvRRrQ2tabaxTt8gQFAF42YHx OrbUaA3DmbsH4zkDY3d7bOb3sz+3HwLjf+IVh7DIXQyJXzRc/LHCG3+kb4ZRH7HdDFsTJ5ZOCX9n C4pxzXspbu4gLAJwRwJj7x6M1xUYW9fnpsXmuq6e7Tk9hMY/41WHsMhdCop/NOrtKDnVfZgmbklR GjgzKShGfTuNcwbFXCtrdE5dXUd7L0VVRQCuKzA+m62RCUnRCIy9lcSbEhhb19d+lua50hAY/1Ov OoRF7kJQ/COFg8X+tTqqMEY6fGX7eWvwS2uMdS5kTWo97QiKXZv5xsRx2zFte46jyqKgCMANDYyL xiTUSesXJwbGWvCcFBgzz1OdclraKzLKFdeDsLjfW2zwyiuv/OdedQiL3EpPnjzZBMU/XBliU3ud piExorF/YqUS2DNA5tQ1itcSFKO+l6KgCMB1hMVoBMZSFfG2Bsbcz5QLhrXQuIy+Ft4jQ2D8L7zy EBa5bUHxC4eLPxTH6xKrb3ijoLiuhMTaZNDSmsba3oXXHRR7Q/CkoLj9xa0ERQCuITCW9mA8d2As Ba6bEBh7guEy6ntMdp0/DYHxz3rlISxym4LiH4zyAu2jhdqFsBjpxvG94SsKQ25mDqfpvv8ZgmIu DK4mBsU0YAuKANzUwFiqQC4zoWmZBs0zBcbe4TnnvH9v62kuNEbuPGoIjP+lVx7CIrchKP6rkV+c 3fPaLIXE3g18V5X1jLV9Dmv3b1UrX1ZQrK1TFBQBuEuBsVRlexmBsbcyODUw1iqJy8rvJuJ40E2p wvjnvPIQFrnJQfFHoz7EZtEIiQftp9GegtoVvjqnlbaC5apjn8frCorp99v//gRFAG5oYEwD4E0N jHNbT6esqaztsbicck41BMb/yiuPlnt+BVyDcdAb/+Fic90iCYLZsFgLih3bQ/S0ks6uHAqKADDN 5jg0BMbx+cDmYBXbhqPVNgitRsEvd/vu+tU2TKWP2xyLN6FtfP/956PHxei22D4m/T6ryvUxCoCr XVgbrl+Mfq59qNs8z+a67WPWu9C3Hfq+yDzX7lwpDY2rUWgcn1MpDjGbFw8v1ZMnT75guPgDUV6E 3TP5NFtV7NxDcFUJVqtGIJuyZUZXq6qgCAAv3OAK49ThM8vKwJ1SxXDZ+G/pXccZ0TlZ/t69e/+N Vx3CIjcpKP5I4c2rd/JpNjRWpqD27D3YCnFTW1K71kBG//YYgiIAAuPVBMYpw2SWMwPjpCmtjSCb e65WaKyeZw2B8c971SEscq3efffdTVD8/ZntMXpfh0dBMROMItrVxFpFsWcwTasldU5QLLWxrmf+ 9wiKAAiM5cDYXHcY9a04etcStkJjK7D2VhlroTF6zreGwPjfetUhLHJdQfHzh4t/JcoTT7smn8bx cJtWSGxtQD+1OtgTFFtrGmvbeLSC4qrjv0lQBEBgzFTfSuEvKtW8K9q7sRQkp+6vuGiExki206ie /w+B8S941XH0uvAr4CVbjxZ+twLL+uBB+TWLR1tnVFpSp1Ttetct9uzdeBVBsbWPoqAIwK12hqE3 i8xtB/ff3a80+CZ5zG74zGo7rCZG32P//baDchbJc6233yO9/3o74GZcAc0918Hwm+3PvHvMuhQY R+cA4z/WG3pDNy8UrtS2qvj7Rq+3o79sjd68IgmHEe3ppxHTqom9bae10Dd1/8bqlNQkkIagCAAv nFhhLFXkSmsSe/Y2zN22nPFcvY8pVSBzralRuE/0nIPdu3fvL3rFISzysoLi5w0X/3Lrjapgnfl8 ckiMxpTUjjWAPS2puX0aD8JfYzuN0s8QM4LiapS3BUUALiEw9rRp9rar9gbGOVNMc/sr9rSlth6T tp3m5kN0t6O++uqr/51XHMIiLyMo/nDUp3AtGiExIr9NRkRfVa1YTYz6WsPerTR6p6r2ro8sVS7n BsX970pQBOCCAmNUwlXuttz6xt71iK01iVO24+hZL9kMwqPQmJ5/df/xfgiMf8krjg1rFrlKueC3 6LhvraoYrZAY7bbTUkjrHUrTtabxjEGxp+1UUATgTmusYdw5WMuY3L5bC5jellvfuErWEC5318fh +sKIwzWJR+sOR8+XrmNcjOY45G7braM8CpO71TrJz3+0VjFZ07iO/ITUdSk0ghcFZ7etKv5gnNZ6 ehAUCwNujiahdlYbVzGhJfXE9Y61Kak9U01b7bTj//4QFAG46zorjAcBrLLdxHLi+sZWlXF3fW3q ak9bavf+io2pqOnvKKK/uviXvdoQFjmrx48ff+4mKCYLpnvCYraymASkqITAiHrLaa2a2AqQtRA5 ZeJpb1BcdYTgg/vkfk+CIgAC46zA2BPU0lbRiM5BNo3W0yk/45zQGIXgmD1PGwLjf+/Vdtm0oXIV duFlkdkiY916YOQnoOaCYmSqftEIbz3Daqqtp4VwGdE3JbVVNSwF3dq0VEERgIsyakkdn0NEZsD6 7ri5GLWWriPZPmPb8pk+Zhkv2kvTVtVcq+j4PuPnPGpJzQTNXFvqInm+WijctaauK6Fx3466fa40 ODbP07g8Kouczbaq+P2F19ecyafFoJhUEntbTtfRXzGcuz6xNUF1zhrK6PjvEBQBuDjbCmPEhM3q OwbbREzbWmNOtbA13bRWSczdFslzpKEz4ngiald18f79+/+jV9rlUlnk3MaLpNMQ2PrLVSkgxoyQ OHfPxZ5KY0+ba7O1NOpVzyjcJigCwNbuuDeuMlYqjOnt2cE225y1isPq47P7d1QL08E3i2dlvBeB Ma0kLjJDcXbVv1Jg3FUGl5lAuDvfyFUan0ah0lg4R1NUwouA83j8+PHnDBffN/O1lYbKo9C4S4kz Q+KUIFgKmK3pqb0Dc1phcBXTtwVZjw+YAHCJRusYp1YYp+7FWNwKI/rXMc7d+3HKesWIw2piachN sxPs/v37f8Ur7DKpLHJOqxl/gCi2nSZVxFpQjForZ/RXE3u3vnj239o5JbU3CE6d6CooAsBIuo5x VNHbnUMcVAqT7Sd25zH7NY0dW2scVQpHj0vXMS62jytVEheZquVBlbEWgCvrGVej0Lge3a9UVVyE YhKtvx7AFNuq4vfMfE2tD9+31xHlLTKOvh6FuYiJ1cRoVBQnDJ05ZZ/EVcyrjj77EBIB4FA6KTXZ oD67JnHi+sCD55i4jjG9rbUdxjKmTT3dTX4tbqGRXrcNqD3Vxf/Zq+vyqCxyDrvwkq5TbD7uRXdp daDN0dentJxGX3WvVqWsTUntmVq6imnrLCMOh90IigBQMKowLkbHz0VStUuriOtkveHOKqkGps+x mLCOcZ3cNp6kejTZtFBlXGyrjKV1mU9H91ln1jSOK4njauN6FB7XoaBE7S8H0OvRo0efPVx8d/p6 St/ARqEwMoGyONAm/bwVEqOvOtdqV+1pO+1dnzh1MmtkwuZ4fWMIigDQNnEvxmZFL8p7LvZMRF00 blvG6WsrS9NRc5NRc9XGXD44OLe7f//+/+qVdVlUFjmHo+CShMOekFgMjaPyY7HdNA5bWOdWE+ds tdEajhMdE08jbI0BAGeVVhh35ydzJ6WObl/FcUvqeB1ja+pppLdlAl2uynjwuBitV6wExlKlMV2z WFq3uK84Fs7tuONUFpnt0aNHnzVcfFe0+9zXEz5Pq4i1kBgxv+W0q+oX04fVtAbVzB1kIygCwAxz 9mKM/B6IEeVKYe32XCUwXUfZrFw2fu5lJXCW/vsjynsuFiuNDx48+HGvqsuhssip1o2ve+7X2iIj GiFxaktqLrD1rCMsPS6ivj6xdrugCABXqGMvxqNJqZn7lNYplm4vTT1Np6Ue3N6oMtamnq7jcD3j OvP4dfo88aLamFYax+sWS3tocwFUFpllW1X8jo7X0bpy3Xr0hlwKh3HGkDilmjhnguqUdlZbYwDA S5bsxRiVSan7y9F9Tplc2lrnePT8J1QZ9881mnRaqjJG8vtoVRafff3gwYOf9Gq6DCqLnGIc5hYT QmJkKogRjYmo5wiJUa4mbqxmto6uomOiabI+MXdp4ikAXKHMXoylSanjKuFuLWJtHeP48bv7rEeV vp51jkdrEUcBbkqVcTE69yhVGteZzyNTccyd5zk3ERahKyiue9841oerolsBMSI/uKb0EXG+amJt /8PxRNKetlLrEwHg5gbGOYNvIgmN+/bPmW2pueE347bYVWWAzamhMfd5LjhGEh65IP7Rmezhw4ef OVx8+4RQGVEeZlMMio2QGDGtmriqhMxaW+nqzCFUUASAG2DO1hqt+2TaWltDc7qfO57vy9jzs0XU 21PH1cqI8pYaaVY4uO611177oFfR3aeyyFyrCfftDoqj4DT+HqeExCm39w6hWc14bkERAG6Q7fF2 PZqWWhp8c3C5fl7qG18fo8fn2lrHbam70JfevqsSphXKg60tJlQZ08fuPp7G4YCbRaHaOL6MzOcI i1ANf+vO+3UFxkwVcWpIjOir9j17c+4Iej1DbEptp73rEw2yAYAbEBpH6xjXhZbR1jrGRRIoS3sj 7s5DFpk9Gfe3xWGV8eA5Gm2nPaHx4LrtfWt7MEblc+44/9BM8vDhw88YLn7XhJBYDIqjgNgVFCsT U3MhMdIAFx1bYkTfoJo56xfTYT0G2QDADXIVbalRbj2NKO/ZmJuWWmovTVtTI/rbUyPK+zBGtPdc 3LSi/qxXzt2mssgc6wnXHwTFQkCsft4TEuMMbaGnhkBtpwBwe80YfNNsS808x7gSOR5+k6syjtta 0yrj/vm251bLzH2O9lXMVBqzn++qjfGiTTXiuNqIsAhdobAYEpNwmAuFxaB4hpAYUd8u49QgWGs7 FRQB4PYGxlzYy60B7GlLHa9FLAbKiKMtNnonni6iPDU1GxrjsO10fJ918tj9Fh6F8Mgd5x+Zbg8f PnxzuPjmbHo82BmjGA6jFRQz+y/WWk4jyusS51YTj/ZfnLl+sdp2ujsgeVUBwM30ktpSe9tWS7fH hO+Ru29uMmrr8qAt9fXXX/95r5a7S2WRbpkq4dFdCmGxGRSTKai1kBiFgHdqS+jZbw/VRAC4tc7U ljpuLU2H37SqjBH5iam5ATjr6KtE5u67Ht03Nw21NPQmQuFJWITMG2FPYGyFx7SKmIa+qITEiErb aSPErQrtratGIM2tX4zQdgoAlxAYD8Jcsr1GrS01DXzpRNNs22kcr2XsaU09+pkqoTH9udeZFtWe wOi8RliEgzefVUdIrAbFTBUxTgiJEVdXCZz1HMl/o7ZTALjlgXFzOQ6NSTUuf2J0WCHsGX6TuXm9 HD1H8ftk1lQeBMdCaEwfMw6Z647gGKGyeOf5B6bLO++884Hh4hsnhMQ0HEYhIBaD4mhN4kkhMfJV vlX0tbfmhthoOwWAC9S5jjFGwfBsax1j+nrHiMKaxcr9cp/vL5MtOPZ54vXXX/8lr467SWWRKdaV kHhwXWdAjEL4iyivSWyFxIgzVxMrYfMgzAqKAHC3TZiWuhoHqqTKmD/Jqq9l3FcIZ7SmHlUPM/dr baexe1xacSydEyIscoFBMbtecZ2MQu0MiEdBsbFVRi4kRpynXTQXTFej2007BQBifHwfhcZ1so9h LRCuO8Nebi1jK3iuO0NjpKExjvdgLAbGJDhG6FQUFiFpCc0Fw9Ln1aA4mrBaCoppSIyYMYE0zjTJ NLSdAgDRNS11VyFMp4+Wwt7BeVdlb8fa8JqjbNoTGkc/13K7j2JXYMyc/yEscsmZsfD55KDYsVXG KSExor/iuLvveG1is5IoKAIAhbbU3dYZEUk7auZ+PVXG2nlZqzW1JzSOQ+HTpNrYCowRKot3mn9c mj796U+/b7j42gkhsRQQI9oVxCkhMeK0CaWlMLl7c48JoVTbKQBcsAnDb3oH14yfZ1l67Pi+HUNy IhMaa8NwWvffZ4o33njjl70K7h6VRXrNakFNAmLt896QGNGuEvZUE1edQfIgOKomAgA5jbbU3LYW L06AylXG3e2rOF5XeHTfUYvruhIY00pjem53VEksVBvHlUXnQsIiF667olgIiLXr0iAW5wiJozfX yesOwxAbAGB+YDzIgZFvJz1Y09jYlzGdYlo7X9vdr7buMTKhMbeW8ahVdftz7p9nFB4RFrngoLgu hcZROGxdrnPP2RsSJwa7U9pSN1QTAYBZgXFz2TH85miLjX2Ce37HVSbgRfJcxSBYCJfrWmiMF1ti tIba7C9H4RFhkQu220oiGqGwKzhmWk2jMyRGTFu/eHT/iZVJQREAmBUac8Nvot3+masytgbg9IbG RSE0ppXDdaF8uY76sBuERS5Npq20FQ6LQbFjCmrvnooxJwDOHJojJAIAswLj5jITGnNVxjSULUdV xigFtxNCYzEwxot9FHMtqqXgiLDIpebFOBxw0wqKB0GwUUWMCSExF/LmtpxGqCYCAC8pNM6oMq7i uNI3peU0DY89ATP9OteiWgqOCItceGAsBcWj25OAGB3BLyrrEXtDYjYAnlJN3L3B++cHAE4NjJvL SpWxNDG1NACnuJ4xCZc9obFWZRy3qK47giPCIhcYFFetANkIiKXwVwt9VxUSc0F1lX5fIREAuIrQ WKkyjs+xlrkwVmlNPVr3mATL9H5paEy33Kh+ngmOCItceGA8+rwzIGaDYrIW8lwhsft+oZoIAFxT YNxcNtYyriJfGay1pkYmBLbaTdP75yailj4fB0eERS7N22+//cZw8SVxXD3sDYhRCGgRfS2nc0Ji MRxGeU3ks0shEQB4maGxY1/G4nCZjtbUVmgstafur08eUwyM/jXvJv+wVH3qU5/ahMUvTkLV5KCY mah6yhrG0kCcZkgsPa+QCABcpyE0jkPbri10Ofo6vf3oulHCXNQek7lf6XtEEhpLj3t2+d73vvf/ 9S95t6gs0jJlEmrvNhlRCXSTBt107NeYazk9uL+gCABct8JaxlX0TS1d7E52Knsp7q8rVBpLQ24O WlTjeCCOvRaFRQTG/qDYqCLGGUJiqzW1df9nVwmJAMBNC4yby21oXCTnMVNaU9OhMz1baOTuu86E 03USHLWiCosIi/XAOAqI6f2jEehOCYkRM1pOx2/GAAA3NDSut62pL06oDgfgtILgsy9GVcBc0DwI jXG8JcaiEE7T4LirNiIscoFBcZULipmAWLrMhsgJW2ZMGV6zu7sBNgDArQ+NjQE4c7fFyN436kNz uvaBRFjkMgNjGg7nBMUoDKKZGhKLgVFIBADuWmDcXE5sTT0KkaPQWLvvODSuo28aKsIiF5sSn79R rAphMEqhMPqH3bTWL9ZCYukxWk4BgDsXGtMBOElorIa/zP1LIfDg+spWHrbPEBbhKKxFdG6bUZlU ekpIPAqMqokAwKUExs1lITRGYVBNLuTlKpPZcDnKmPvrC0HTeZewiLDYvJyzZYaQCAAwLzTWWlNb wXH8mK4tNOK4RTX3/AiLXFBQXHUGxJ5geVJ7alTWJY7fPAEALiQ05qam5lpNc8EubTeNRrtp7jHp 4xAWucDA2AqI6f1agS9mhsTszyMkAgCXHBob6xnT8JcLkTEKgOvGGsijQLk2DlVY5GKtGgGxdHl0 XfJG0ltVzA2veXa1kAgA0FzP2DM59SAI7v6wnwmNuXWN2lCFRS5RreUz6lXEXNDrCZVCIgDA1YbG anVxHApH3WCldY0G3AiLXHpmrATEYlBstJpGTFvLuL8UFAEAJoXGgzDXUTXMhcfd43LrGlUWhUUu 2KoQENOgt8t5XRVHIREA4KWExt0QnMXo/GuRCY21EJgOtsm1tiIscmG6ts3IVBGroVBIBAC4kaGx FhTTMFnbrgNhkUsOjElATO8nJAIA3MDQOFrPmIbGXPDrCY37rTcQFrk8B22omTbT1mUuIIaQCABw PYFxc5kJjTE6V6uFxtLXCItcmHW020yzobAREo8Cp5AIAHDrQyPCIheTFF+ExNY01FZILD5eSAQA uHWhUVAUFuGZ1jTU3KWQCABwC0NjHA/COQiNcTxBVWgUFrlQk6qKlfWIQiIAwO0KjrvQeHyCaAqq sAi1YBjlKuLRfQREAIBbGxrHLarZ0BgG3AiLXHRYPAqCqogAABcbGgVEYRGOw2KliigkAgBcVmhE WOTSg2JPFVFIBAC4rNAoON5tVqRStV3UvMwExP3XAiIAANw9Kov0UEUEAABhEYpBUUAEAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBme+uttxabD7+Ju+eeXwEAADAnJG4/3V2u /VaERQAAQEAcU1kUFgEAgAsNiGkoXAiLwiIAAHC5IbEaEBcDvy1hEQAAuOyQmAuIwqKwCAAAXGBA 3OXDYngUGIVFLvONY/9//jfffNOEKwCAywmJaRUxvY/qorAIz//Pvw2OQiMAwB0PiZ1VRFVFYRFB 8fANYBcaBUcAgFsfEltVRFVFYREKSfH5+8VivV6X3nCERgCAuxkSp1QXERa5UMvh/eNZGExC4zq0 qAIA3PSQ2Go1nXs5zplCo7DIBVokbypCIwDA3Q+J1bbTTEAUFoVFLjgwRvIGITQCANz+kNhdTawE REFRWOTCw+JiGwZzoXGzpnEtNAIA3MqQWKwibh9r7aKwCMWguBwFxcUoDO4vR4NwhEYAgNsVEltV xN4JqQiLXGhgHAfF0n26QqPACABwlpBYCnqtQJitKiZVxCkBUVAUFrnIlPgi/I2DYra62BsaVRkB AF5qSKwGxkoVsXuPxdH3RljkkvJijLbOyATA9L49oXH3Zic0AgBcX0icMw21FA6FRWGRCw6MpQBY rC4KjQAA1x4ScyFv6lTUXEC0XlFYhIM3iTQAPrsstKjWQmPkipNCIwDAUVC8qpDYO+imZxKqwCgs csFBcTcNdRf+DsLcKAD2hMbdG8+6FhoFRgDgwkNiGspq002LITCzHrGrsthoURUUhUUovgGMQ+O+ DXUUAFuhcV0JjYbgAABCYl9ILAbGSkgsrkXMVBF791QUFoVFLjIlPn/PWD7Pc9k1iuvjhzRD41GI LFUahUYA4IKCYqkNdE5I7K4mdoTRiPaWGQKjsMgl5sXRm886ymsU15UAWKsuHgXN0hAcgREAuLCQ WAyFmfO0rjBZeP5WUIzCzygoCotw+EYxod20dv/I3Hf3gNje/ygwbgiNAMAdCYlHIe2aQmJty4xc QFRZFBZh/3/8dMDNOATuJqJOCY3j2yYPwREaAYA7EBR7W06zYW5031ZIzLWa9m6ZUQuIgqKwCM8s 47jVNDfcZkpoHHebNofgmJoKAAiJxS0wpoTE3i0zIkxCFRb9CuiwSIJca7hNT2iM0T6Nperi+Imf XZqaCgDc0pCYnlP1tJzOComdW2zkfp6egCgwCotwEOiefWTKe63hNrUguP9698aUue9Rm2qtNVVg BABuaFBsVROXSairhb+5ITG7LUYmhEb0D7kRFIVFeN6GmlQCS1XG3tB4FBw3T985BCc7NVWVEQC4 YSHxKICdUCGccr+IxpYZhcE4teuOwmFmX0aERS7QIjLrE6NcDcyuO6yExtp+i1NaU/ehUWAEAK45 KJ6j5fRcIbG2JUd3UMxULoVEYRFB8Wga6j7oVVpI4wyhsXW//X1NTAUAbkhILAW0UjjsnXA65b7R ed9qUJwQDgVGYZELlpuGGklo7NlCY3IY7GhNHa97VGUEAK4zKPZUE6e2nJbaWJuVyqTVtCsoFtY9 loKhkCgscsl2b0ijwFbaPmPKFhrpthi5yaqRBMtWa2pxAI4qIwBwxSHxKIRlWklzQXBqy2nvGsZo fO+IcmtqLRDWgqLgKCxyoZbbEJYbcDN1jeJRaBxVBdPqYus5i+FxW5FM38wFRgDg3EFxVjXxhHWJ U+8b0b9nYxRCo5AoLEJRdsBNpdq4/3rCFhrrSgWx1pqa3e8xVBkBgKsNiUchrLOa2AqA52xhLf2M 6fW1gJi9z+EgVIFRWOTSg+I4vI3DWGmtYm5/xNYWGhHlquQqc59msByFy/RNXmAEAOYGxSnVxFNa Ts+ytUbyvWPi5e7xuVAoJAqLXLiHw8dvDh+fn3lzKK1VzE447QiNtfWMyyhUGeNwGmsu7K5NTAUA rjAoTq0mLieExMg8Vy2Y1kJsZL5u7cOYC4a5kPj/eIXcPf4aQNPbb7/9nuHiK0YhLXd58Pk2mJXW H65H98ten3703G/Ccx39zAIjADAjJNZCW6uauDjzc7VCYvO6JCD2TEPdX/fGG2/8714pd4/KIu2/ KDx/51hmglZuaE26XrBYOYx8pXH8XPuPynCb8Y/ZvE9UqowCIwAwISjurluWgl5PpbCn5XRiSGyF wykB0f6KwiJ0WW6DVsRhFS835CY3tKYUGseBtGsbjdF9ss+XrFEsDsnZ/lwHgXFDaAQAckNshvOH YjCMedXEqwqJtc/TNtZSKDQBFWGRLuM3poM1irvkGJWppB2hMbeNRi7orUtBLxcqo15lHIfP9OAg MAKAoNgTyKZUE5fR33I6pyoZUdlTsREoewKjkCgsQtFuwEyuephWBUstqr2hcT2qIKahcZUEvSlV xsg8nyojANAbFEsh8NRq4pxtNZoVxChXESe1nab7ZAiPwiLk3gwWpcAYh9XG0r6KpT0VF6XAGMfV wWUj6JW22VhXKqDFYKnKCAAXFRIjpg+emVNNXMa0ltM5IbGnLTUbFJNwaK2isAjNoFiqLEaU1yrm pqJG5X5RCnETg2Vxm41a62ocD7959t8kMALARQTFni0xlicGvFn3qbTAxowweRQQC+FQSERYpCMp HrYvrEctpLnhNrkwmGs7LYXG3tbU4s/aCp6VFthcON0dRJ5dCo0AcJFBsdYuuox6NXEZ9cE0y6gM sOnZx7ESEotBMak8pkHQWkWERSbZVxa3wS4NjqXwODk0tgJjT6is3SdpgZ0UPFUZAeBOhcSI09YL nlopnNNyWnuealCsBMRSUBQShUVo+vTw8Y+Hjy9PgmAaHKuBsSM07kNaK8y1Kog999GWCgAXHRRP HWKTrjtcNqqJyxlB8pwhsRUUS9XEnsD4K15VwiIX6vXXX3/yzjvvvJ28Aa0LwTGtNkYjNB4FtJhW IextXR1/HExUrTxHMbwKjABwEUHxbNXCwu3LE0Nia6uMiL6hNq1pqNXf6WuvvfZxryxhkcu2e0OL KLecLkYhblHYSqMV+I6CY6U1dbV7A5swICcimaja8xy5+1jHCAC3NijuKm7LUjCbEAKXybnSqdXE uSGxVEWsBcN0HWMaGHPngxGFyfIIi1xqUnz+5rHchq716I0iGxi3IW8f+gp7JraqhLv7rwqtqcuY XmVcjZ+3FgYzb45pW+o+NAqMAHArQmJEfsLoMndZCYJzQl7r8bnwt+ypOCYhsRUUx9XHNBz2TkAV GoVFOLLcBqZ9MEwqgqUq4iKzZ+Ii+ttGe0PhqqPKuIzyFhvr3rZU6xgB4E4ExXNV+5YxvZq4jHbL abXyWRjIE9G3djHCNhk0eBHQ5eHDh5s/LHzB8PHVSTjcX2YCVhQ+z1UQj8LZ9j6rynOsolBFLAS+ VeP29ZTbk/D77GuBEQBud1DM3H5QXTxzNfGUSam1kFhbv9gKilPywea855dfe+213/Zqu5tUFuky vAk8GQLjp0ZvPrm1ios4Xn+Y3SajslZxfJ9NuFtmguXunW9ZCYW5ttKDSmKmijm1LXVlHSMA3Pig OF6feO620+4gOfr+vS2nvSGxtPdiRH3NYu3zKeeIgqKwCEeBa1G4jFGb6jqzRUYrNI7vs4zOvRdH axEPQuH2+VfbQJddpxixXwu5jL622IP2WOsYAeDGhcSIq9sbcRkTK4qdz72M8tYd3UNuOqeglj7v DYzOcYRFOLJIAlUpMLYmo2ZDYysQxovW0+MfLF9l3N13OXr+ZeS30FiVqogz9n20jhEAri8onnN9 4vKUoFeoJi7P9LOV/htbQfEoGC5ae2OkSfHFOY8lbRdw8g9dHj58+Opw8UXD+8nXxYuhqGnLae66 9Yv3luY6wKjcZ7/msPY8lbWMqwmPjUjWOIZ1jABwp4LijPWF47bV0u0933t5wtrF3fePzH1qQXGR CYZzs8DunO3vvvbaax/z6ru7VBbpNrwZvPvo0aNPjN7E9hXEJDguCp9HZl1jroq4S5bpj3DQXjoa gHP4F5DjKuNq/PikirmqPHaZ3mfufowCIwC8vKDY2D8xXZ/YaitdxvSW1HTS6TLmtbPmqpK9ITEX EOdsk7GunBsKisIiHL2JHK1brATHnq00Wq2npdtzA3AObs+sRUyH3+TaUtPA1xqMc9DSGpl1jAbf AMCVB8XW/oldawg7QuSyEECvsprYEyRzVdWI0wfbLJLAuA7dicIiNN40SusV0+BYCowxJTQWqojL 1u2Z25ZJ2GyFwtIayag8Nhc496FRYASAs4XEiPMMsqm1lUYh7OUCaHaaamOAzTlCYu8E1No2GYsk EIK/CjDNo0ePNusWv2T4+J1xvJ1Fcf1iuo4v8sNuVifsfThej5hdd5i0npaet7VOcfI6xtyekgIj AJwcFK9yfWKpEpl73DLmVRNPXbdYqqbWLntbT3OBMT3H+6UHDx581KvxblNZZJLhTeFg3WIhLOb2 YKxtpbHfiqKj9bS03jDdxuJge4s4rBT2tKUetKRGRPX21qTU0eNNSgWAmxsUS7el17faTpcz1ya2 nrsVEmsBcdEZEnusBcXLoLLIZNvq4pcO70/ftA1BtepirqIYMb0id1TVKzw+V2HsnZi6OsP3NCkV AG5GUGwOsmmsT5zSdrqM86xrLG23UQuaER3TUEdDUCftpZhsDba7/EVh8TKoLDLZprr4+PHjT8SL at5i9OaxKLScTh5yk9yeVgRLVcbl6LGlbThWmzfi3GO3j1tV1jGuSlNaa1NWt//9K5NSAeA8QTGZ eDoObRHTKn+tbTF6gmDutrmtrlPaUiPKey+m4XBWkWj7POPusIWgKCxC1/tHHLaiLkbhcRwcW0Nu dgFssQ1Zi+iberoatXgu47jatywMv1lGflrqQWgstbt2Dr5ZZkJq2iorMALAtKC42wpivDVFT5tn LUT2rk9cdgzH6alQzqk2NofbRBxsqZGGwymBcd04x3HOcmEn+zDZ48ePN62o/8Lw8S3RMeSmY8DN 1GExpUEz2fbSKLee5h63io7hNmcefPPs9yM0AkA1KM6pwE0ZVpNen5tomgbU5YSK4TLa6yHPNQV1 yvYYpbB4dF43nL78woMHDz7ilXkZVBaZ5f79+5tW1I9HobqYvMHsW07juNo4dW/FXZtodkhNHFYg 09bUqFQnl7l216TtdJn5fuPBNwfVxp7BN7bWAIDzBcUTB9ksK6GutefilCmpc1pkI5KtPArDbVp7 Kk4x3k9x3yEmKF4WlUVm21YXv3z4+NbkjaV0eVBFmzAQplYRzN1eHVRTeM5V5TlrA2xyt/UMxbG1 BgC8pKA4YZBN7/rE5cQpqcvo22pj6n/n1KC4yATC0te5c7hfuH///oe9Oi+HyiKzbaqLg7fixV+5 YhR+DrbOiOP1ivu1jY1K46qw/i9XZcytOTyoLibP2buOMb0tKo/bXTdpa41k0pitNQC49JAYMwNU T4Uvt36xZ31iKfD1tJbWqolz1y22tsw4mHJTOg0Zn8AlQXF8Drc79xMUhUWY5KgnfjeJtBIcDypp hdCYTihtDZxJ//q1qrWlJkNzagNsDkJjY/BNaYrqSmAEgO6gOHUPxVLVsBX4cmEvDZDp806tQraG 35xSaTwKiqNwuKgFw8hUFHffJzmnSpcacYEn+jDbu+++e3+4+Irh43dHuXVhHBwj6q2nURpEE409 EqPSYtpoE822pGZuyw2+WXX+fM3bQksqAILinD0Ue9b9tap/y2gMnamsT6x9r97A2rPVRmmLjGxV sXGuX2o/zS0V2l3/cyqLl0dlkZO8+uqrj4fA+NtRHnSzv5ww5GZZub24R2Lk21ZzW2gsC893VE1M bhtfH4VtN2L7mNLWGsvKXozp0BwVRgAExWltmz1bYyxj2nrC5YxwuZy7BcfEkDgnKOaC48F52+LF Pl/7cztB8TKpLHKybXXxdwwf3x71hdFH100c/jKlItjaDqNUfZw0+KZzsE1tW41Vx3/7s9+XwAjA BQfF1j6Judu6J542WkinTEldRl9Lak8lMb09KlNSI/q2y8hVFLPna8k5zqaq+FterZdHZZGTbauL H0vepNJxy0fbaUT/Vhm7YHhUEUzC38EQm8hvh7GrCuaG4uwe0xp8c/CY2tYalerj7p34aAuQ8X1U GAEQFM8SFEuVvlqb6JT1ictotKTWAmTjv3u8LrNnuE0pKOaCY+m8LUbVxRAUL5fKImexrS5+1fC+ 8h3xYqBWa/zy0XUdW160Kny19Yq9VcFSlbG4hjHOU2Ws3b7/PQmMAFxYUJyywf25g+Kc55qyprE6 4KYx3CcqlweTUJNzida52bi6uDkv+VvCorAIJ3vy5MkmMH718PEduTekyoCbiGn7K66irzV1NfH6 8W0CIwBcT1DMTjedOLBmalDMVQBrU1Kn7LnYs43GlOE26e8tPaevtp+my1xGn6/Sc7LBhwTFy7b0 K+Bc7t2793i4+GiUp4HtP7a3LUf3Ofh69Ka7zNy27Lht0Xt9YS1C6eesrV3IHXiWcdoahfFj9weG 0R5UACAo5oPaMjmfyF2fC4qlc4bcMXpZOMdYFs4xWucypXOlZe78pXR+UwuZmcE4xe02BEWccHJW o+ridyU3zRpwE/WKXE+L6VEVsDT8pnJ9bejNpCE6Ma3CWHrs/venwgjABQXF0h9ba5W7U6qDrT8U T21Jrf7xuLXfYmT+eDzhnL60pVnt40Ovvvrqb3rVXjaVRc5qW138WOQrh+llz1/PqtXIpFWkeX3t YFC5flm6f2WqWuvgNbXlRIURAEFxFKxqoW/CMT3tJqp1IKXnJ7lqXrWaWTrnKbSqlqqUpc6sbBUy CZPZNY05giLCIldl04r6S6U3vKi3apzSYrrseINvvpFPCJjVkdoTAuNSYARAUOwPirn7R76iVzpe LwpBrauaOLEltedcpecP5otGKCyta1zG9Erkh7xq6XmhwCxPnjx5MFx8zfDx3clN2XbUmL+/Yqv9 NNcymhtw09XG2tFemvsepWE9vQNxWrc/+z1qSQXgAoPi/utCUJyyH2Jve+my93kq/y3LCftBRtQn oZak51y5ATa585OfVlVkxz6LXM0L6969R0+fPv1oHFevd29Oixjttxjz9lc82D9x+8Y7vn5/+3Y/ xIPrds+VrAMsPc/uQDR+nhgdsMb7Nx48Lrl+LLdP48FejKPbjg4K9mEE4JYHxcWZg2JPhTDtGupe bzjheUohsbrsJfqmoOaG1ByFxO25TXqutYjDSfXZxwqKRHKSC1flI8PH3ym8sS6T9QZTJ5+2Wj3m tJ7WRmc3913KHAByLamtvZd6p6Smt0doSQXgdgXF7qB0w4LisjModi+piY4lOYUJqMXfVyNQZoPi 8PEzXrmMObHkSj19+nTTjvp1w8fvLbwp1aZyTd1D8Rytp7X79+zDOKcldeqU1Nrtz36XKowA3PKg 2LU9xhUExe4W04779z7/ohb+MpXYRSPw7S8Lbaalc6sPqioiLHJdgfHrh4/vLYTF3HYac7arWBUC XS5I3qnAmNwmMAJw3UExol4xPKgUnhAUp6xRnBoUz3H/1jC8ZSlAZ35nEceDaqrnVZWwmJ4j/c0h KP6GVy8pbahcuVdeeeXRcPHhyE/3XGbeUKujpYePV6Lc2pGbspp9085tvNtoG+n5q+KUltRzbauR /aujllQArlHr+HWbg2JpsvsiytPes9thRP+WYb2TT1utp0d/pN98IigiLHLdNmHxb0d+8fr4ze+V jjfYRccb72JiCCzt0TinDeXKAmO0N+oVGAG4NqP20ynbQU0KilGYOvoSg2Jp7WLrD83N7TBae0/H 8dZgPQFxHBRz/qZXLrW/+sBLsW1H/YbhDe4HMm9euTWLrfWKpbbRValdtbK+sWdt4yrmt6S2Wmdz t7VaTlfR3nbk2e9XSyoANywoRiZMRTS2m4jKNNFrCorZIXYz//Bc+kNxjAb8HAXAE8+fPqiqSI2t M3hpNu2oq9Xq/9y+8f1A8keL8XYZR331oy0uDrbFyGyJMd76IkZvjsvR86Rba+Suj477RuVnifT2 0fXj77GobY+Ru260ZUb2jz3JlhtCIgA3KSguMkFx0REUFzOC4uIqg2KmS2ocFFtT1nvWM7aG2rS2 wyjtab27TlCkSWWRl24IjJsK4zcOHz+YvMmVKmTnqALOvX53Xa1K2VvVLA3nWZWG1zQG3rQmnB18 rboIwA0IirltMHqWYiwn7FtYWlZSe56rDIq923QtIt9Om56zp4MBp3Q17c45/rqgSA9rFnn5L7rl cjPw5leHj78VmXWHcdi337MgvOevdXOvL460njFKu9ReMmUS2pSD8cHX1i8CcMVBMTqPTRHTBrmd EhSnPM9LC4qlITaV9Yy96xPXma/TqqKgiLDIrQmMPxv56ai5RdzpEJraG+85A2PPXwRLB6OuhfyF 5xEYAbgNQTG2QXEZ+cmci+ivGtb2XywNwIlGwGs9zzImrFGcGBRL5yWlP3znJp8uo2+ITXH/5dGH oIiwyK0JjA+Hi78/fHwo8tXFg8movW+qMwNjawLpsjHZtNVCMmVtQs9zTQmMMT6QCowAnDkopkHm lO2feo5/y2Q9X/NY2hkIa+G1NcymNl19EZWp7YUq43hC/KJwzp5bhrK7PrdU5a/fu3fv1716ERa5 jYHxZ3b7K87461zXSO2Ov0z2/JVxantMbs3BYsLB6ZQK4z4kjhOjwAjAuYNibvumqGyZEdP/GNob CFvLRlrH3OWUba8arae59tWeKuN+n+idQkiM3CTUwhwEQRFhkdsbGIf3wb+3CYxR32do0WjnmH1g iM71ixOD5LIW8hrhdRFnDJOZECkwAnCq0vFn2bg9HXRz9LjOeQHNbp7CdcvKWsfuNtlGp1BtbeUy +lpXx229aVBcdwTF3cdPCYoIi9zuo81isakw/h/xfGPY3ICbxYTA2HoTntIy2gqAXRsIdx58eqbB TQmFtccJjABM1jn5NKKxVj8yLaS7r0vHxlr4qxwze4+9vcfk3B+Uqy2pE89RxkExor6P4qrjOkER YZE7GRinhLjWdV3rDM8V9DoPcK2AOW47qT2+VF2MzsAIAOcMirXJqBH9f/ic207aHCoXfUN0alPS e6qbvecEpdbVNCgehMDcntSZ635SUERY5C4Gxl8ZPj744qrFnDfdWRv4dqxJbP4lc2roPCFgZkPh NmOakArAVQTFKATB7j94TpiKeuqSjpP+0Fvr8on57bHZeQaj75ULf+me0D3XCYoIi9zpwLipMP70 9k2v9lfJ1sGh2k4a/WsSe97wW39tXTYOdt3PH/XWHxNSAbiqoDhea9gKg93HwZi3RcakKeETppcv Op97OTVAVv77I15UDTdBcbUNfWko7LlOUOR85+V+BdxUw5vfa8PF5w2Xnzdc/lDke/JXhb+wjd84 d/dbxfFf6NK/3K3Gb9Ydz5Fen/vZSj9frq2k9PzF9QiF711sU4nKPkxvvvnm2isPgFJQjPYfYCdv KRX1ZSOlITK5fQ9L9y9NOF0W/si8PNM6xdJ9a2s4IwrrECtBcff1X9t8LihyTvf8Crixf8l4XmH8 J6vV6je3b4Q/lPlDR+5yHYXtI55no6ODXoyuXyTfo/Qcy+0bc3r9+Pk3B5tV8j2fPS7zs+yfqPD8 kXn+9DHp4yJ53LryB6Jntw0nBSEwApA7LEejqyU61jFGuRtmSndNsy00pi8xqbafTmkzjXrXTxTC YSkorgt/7D4KikNI/DUvU4RFLs5ma40hMP797Zc/mDl4rdOQuA1Jy9Eb6/j68Zv1Lrztrl8kISwN j7kAWLo+F2bTg8RBuMuE10h+xnXmALPI/E6yYTATyNMwCQDPvOSBNqeEv2XH92htNzV1nWIUvo5W oC4cc9e5sJh0T5WqjIIiwiIC4zYwbqqMnzt8fH/mboskFK1zb+KNy7Sit9y+Ifc8fvfYRSb89YTO NDy2Quf4wLQLfUeh8HnmXRdbzpPAGKqLACRB8VwDbU4Ofue6PjqrgZn/tmXr+qgv81on5yzpbbll JOkSmd11P/HsZF5QRFiE54FxuPj/Rm2ppcD47A13WxlMq45RaEdNr1/XwmGmQhmj51hkwlwudO4C 4+I4v2UDZvo86feOzHOt47iNNRcY1+PficAIICiOjhFzB9pUB8J0BLw4IRDmtqIYX5/+t2QDcabN NCI/0TRGz3F0jB4fk5PQeNCCun5xsM5VE8fB8SeERIRFyIfGR0Ng/NXh098a3jc/Z7j8vkJozAW+ NDym9zla79gZLsd3z61f7L3/uhEwW2sUF0koTMNkZA5c44C6/1pgBLj4oNj6vGc7iYgJU7trVciY 0Koa/ZPEa5XMUkCOxm3Z6uKzNp9FvuiYhMQ0LI4rij/+7AReUERYhHpgHC7+6dOnT39rExqHj01o /N5CYDwKj5ngto78AJtxZa7VhhqRaWVNQ2A0huhEkiQLAfMg2CX/DcVhOJmgaOANADk9A20iUzms BcvuoBnT2kyPvk9ji4pFTxAeVQ+j8vNH5Th+tDRmnW/zOZhMHsfVxM3HXxUSERZholdeeWUTGv/Z EBo/vL3qexoHvlx4rFUgF5nHl9pR0zC6zhxUp6xfjMaBqDXYprR+sRgkDbwBuFwzB9pkw9acvRbP 1H66aLSf9uy/WA2Hi1J5MH8MLoXDVlgct53+uJCIsAgnhsYhMP5fw6eb0PjZw8d3VwJjRL4ddZzz jsJjsh6xVqXcXd1qR02D5zp5/lwgjcz3zX2PU9YvGngDcLlBMTKB6JR1iultreeLmDaFdPLAmsxz RCXsls4jSl/nun6iIzjuOpLG1cRNy+laUERYhDMFxnhRZfzw8F67CY3/UjkTZUNhLVBGlCt9uSms 6dYdEae3o0YcVzZ7HpMLk6UDVnq7dlSAywmKtc97g1o2jM2YTLqc0H4aMb06WdruIypBuXTcjkoQ rN22FhIRFuHlh8Z//uTJk4/Ei0rjdxUOALm/+OWC5Hp8Q5TXOh7cVpmOmmtf7WlHLYXNU/ZfrN2+ v8/mZEJgBLjT5qxTPGU/xVbAiwnfYzk1QE4Ih2nFtRgSM0NsducQ2X0VR2tDhESERXipL+579zah 8deG0PjR7Zvwd008YK4zB51WcKutLeyqMM5oR821nJ59/8WwhhHgznlJ+ylO3iYj5reU9t4/Ci2x vWsSIwp/cK5NPc0ExN3n1iUiLMJ1hcYhMP6D4dNNaPzM4eM7KwGx+OYf7eriunNN43jtYC5ATm1H XZe236iEydr6xbTCun8q7agAdzIo5o45U7fJaLWfTgmDpRAZJ1QhS/9dR8faCUExt2xlFwhr4XJ8 +RPbcxVBEWERrjEwPo7nVcaPbEPjZw0fv6cWGkvhL9oVwlaQXDTC364dtdZaOqUdtXWf6Pge+68F RoA7pzZFNCJfdYxC6Oqp+KUhshQIzzHEJnI/y+hbt+YHHBwvR1XD0rF2XQiI6ddCIsIi3NDQ+Ovb 1tTNx2cMH99eOXiWqozjMFVa69gVJCsBc7wOcnywLrWjrk9oR80dNCN5bO6gB8AtdIZtMs41/fRo i4tS8KusScwGvUK4rYXcYkgsaE06zd33rwmJCItwS0Lju++++9HtVb+742HjVtRdYOsOf6XQ2BEw a/sn5vZ9zN2vFCZ7t9NYj1tpVRcB7kRQLB3rIqZV82qBa9Jaw1I7acdjc983Kj9P5I6xHesVS1tv lY7P49t/UkhEWIRb5NVXX308BMZ/OHz6sXheZfy23sCY+ToNf7XrW6Fyd8yqDbuJKA/eSW9bN0Jn 7mAYtecWGAFubVA8CFCntJ9WqorROdQmekJlZ1WxtTXVeLBNj9oAm1JgzD3+J5+ddN+79+tegQiL cAsD43DxG0No/NgoNP6umYFx/HUpvLWqi+PbSkEyOgbqROa28RQ27agAl+kc7adRCJm1AFqrCvY+ pvT4iPIgnNrvoRUSI3dM3x0PG8Hzp4REhEW4W6HxN4fQ+Nvbq7614wCzrnx9dFtn+2rEcWtpbytq Omk1FwoXhS0xtKMC3GEntp9Gx3XRCnmFoTbVITmNqmJEo7U0ym2pxynxRdUwd8ztmXq6W67yN4RE hEW4o6FxCIz/KJ5XGd8cPr6lERqPNrbPtKJGVAbjJI8pHZyi8Zh142C5bgTd3H2bIVlgBLg1QfEg PFXaT8dpLBsGa/sjdq47rD1f7fFRuT6iPaimd3hNMygWjqUffHaCLSgiLMLdDozDxW89fvx4U2V8 a/j4wPDxzZ2BMSohr7RPYy3E5fZkbIXDuXsvlm6L5LGtUAnAzdPbflqtABYqfRH9ezHm7psLkj2P OQqBhRbUKRNOS9PQa8f9D27PH37DywxhES7E/fv3301C46bS+E0TDsqT2lQb9y1VFyMTPlvDbiI6 W3Jyj0vXN6ouAtxcjfbT9BgwZQ/D2jrGUoCbWlXMBr0JLag9wfDg66QVdRwec4PhflpIRFgEoXET Gj88hMa3tgeLb5r5VNVAV1hrmK5DrAW/g+edMOzm4ACbhMHaz77/WmAEuPFqVcWI42mhuduKk1NL awtj2jYW42NRrc10ajtpNI6dB19vjoGZ4TXj0LjxM0NI/E0vK4RFYB8ah8D4T+JFa+rv7DgwrxvX 97aj5tZLTKkuHj33icNutKMC3HBpVbG21jD6h9pElLfa6GlRTX6cdiUx6i2oU4NiaUnHQUfPNjDm juMf2vyPoIiwCGQD43DxkUePHn18uNx8vH/4+IZGYDwIVMlU1DT4rZM9FFvtqFEIlc8+r1UXcyGx cGDtoboIcHODYle7Zm094tyqYma6aFdlsXJd63gblWNZ96TTiMNpp8N/xs8KiQiLQJcHDx7kQuPX TwmNUV44nzuwrZPFgqV9EqdWF8867GZzciIwAtwoU4faLKJzmExMryoeDFsrBcLaPomF9tDuauOo xTQXFNPLzcfPbUPib3kpISwCc0LjR4fQ+IntVV/XcdDOhsHO+029/9TqYsS8YTelnwuAl6xzqE0U At/iOJ9Nriqmt0UrPDaC3zm2wYjMcbL1B9yfv3//vpCIsAicHhqHwPjPhk8/PoSnTZXxazsOzutK 2Mten9l6Y3xUTvddLD3v1OpiLfDaexHg5uqpKsacLSqiXUmMyv1eZkg8Oq5uq4ulvRM31/385hNB EWEROGtgHC4+9vDhw08Ol5tK4/uGj6+ZEBj3x+zMONLaoJtaiHv29RVXFw27AbghCkNtSseLZstp raoY/dNMc4NtpobE1rGpNTH84PrtDhnpMfUXtiHxw15JICzClXjttdd2ofETo9D41ROfplZprA26 yT32qquLR7epLgJcW1DMBa6erTIiJlYVJ0wzLf08x3fKh9s5QTEXHMfH0f2xbfiWvygkgrAILzs0 Phkufntbadz4qhlPc1RF7Bx0kwuE564ujr+v6iLAzVCqKpYqg1OqilEJhV2DbSrHljlrEEt7JHZt j7G9/DtDSPyIlw0Ii3BtoXEIjL82fLoJje8dPn7HzAN/ayF+7b65EHdqdbH6M6suArw8la0ySi2k U6qKR7dXWkkXlergydNMCyGxdZ/c57+0+Z8HDx4IiiAswvUHxnhRZdyFxq88MTROaUX9/9m7E962 kTMMwFSCdmPHVy/0Pvb//5ACPdAL6KLFougW23bTdnflO7HjsDMJuUtTPIYUKcvK8wAUJYqWDNkg 59U3nEkJjVnHz/T/cqqLANugbdCaLEuvKmYNg+L0hby+0Dd0/64QuOh6Li8uSKztX56XfhkfC4nQ 74mPADYfGsOyDHc/C8vH6zQEGk64i9X2QeO8VoO+Pa797KDfs3b9DAAzaJgqY2hVse/ckDKP4jr7 p4bEPOG58nrElW0xKIaQ+LmgCGlUFuGB7O3tvb6+vn4R7l6E5XlYPhwRGPOeMJlSVczqgbBjJNb+ X6qhuhgbMbqjAmxEalWxMxx2zZ1YCZpd1zm2nT/m+AKxbdC3ssIY7/8q3sSg6F8EhEV4NIExrE5D aLwM67jsh+UXI0JZtkZobJtjqn4iHvK+qaEWgDWNrCq2hbiuuRCzlgDZtm0WxQA29fNYW2j8dRES v/CfAsIi7ERoDCfCGBp/PjKIdYW/poFs8pbnu8LjkCCrugiwGW1BMMv6q4sp4XDM3IeT5sRsdbCa emgs7/823jx79kxIBGERdio0nl1dXV0Wm36W2jioBcRFT3fSvu6rWdd+qosA2yGhqrjoCYoNh/hF 51yIHaOg9gXIxYhr35vC4KJWXax/+fmbEBK/9N8BwiLspP39/bsQGOPEwGXX1J+ODY0toS+lK2py eGxrEBgZFWCzUtJY4nQZQ0Y1rb//lNXHtpFPm85fv4s3giJMeEzxEcB2C6HxaREY98Lyk+zrEd/y ykhvjUvt+Tc9z6/s1/X6fe/dsM/bk7uuqADTaJpXsWG6i5Wlb5/a808q7/Gk4+ebnssqPz/092sL sk2jf/8+3hcSYXoqi7DlYpUxrM5DaLyK2bEIjT8e8VJ9XVDr+2W1/e9VH1O6olb20Q0VYAv0FB4X iaOg1s8ZQ7qi9smLLqaLlvNQ9fEf4k0xHRUgLMJ7HxovQma8Ljb9aGxbITE0Nu2/Tjeit6+1XC4z 1UWA9dTmsK1X7bIs7TrFMV1QU0LiWE3nmaYRTuPjP+7t7QmJICwC9dAYAmMc3S2Gxmdh+eFEoXEl RPZVD0cMdAPAdPoqeikjoA59j7VCYmVgmnogvPdelfkR619Y/ik+CEHx1J8fhEWgJTCG1cXl5eV1 JTT+YMLQ2Bogh762aTQA5g+MIwa2aT5g9wfF0Tmx5TVSq4l/FhJBWAQGeP78eQyNITNevgzruHwQ lu8PSHJtlcFFwsk9peHQNsKqoAgwUuJ0GVnWM0VG1l5p7Hs8JiimnEfubSuqix8VIfHMXx4274mP AHYjNIYlTrMRv3F9sYG3HNRwqM3JVW3sADDfcbotSHZdnzjlsbk6GnbXtqy2rdznoxgSBUV4OCqL sGOh8fLyMgbGl3mexyrj92ZvjfRXJ5saA6qLACN0DGzTe6ye4ng/g6bLHv4SH+/v7wuJICwCUwfG sLq6uLiodk39bmpboB7iYiMkv58G24JeWxcjAKbV1a00pQvqQyp6ly7K80Q1JP413gkh8dyfGIRF YEYHBwdvwuo6hMZXxabvDGyE5C0Nk7YpNDrDYdOciwa6AZg1TLZ1N13pirqYqWzYcJ5oG0TtYyER hEXgAUJjCIyxK08Mjd8My7fXCI19QbDvtbJMV1SAUcZ2Qc26p8zomn5jqkFtmqbGiL/825AYH4eg eOEvDMIi8ECBMfu6yliGxm/N+Ja6pAJs5vhaD4OrT7bnyb5RUocnxPb5Eevng78JiSAsAtsXGl+G 0HgT1jfhnP6NsD6ZoRGTtzVYdEUFmDVErhP21u2Kmve8Rnz+7/FOMYI3ICwC2xoaz8/Pb4qT97qB MaXLqq6oACM1dEHNerqgrtuNdGhIbAqb9WsUPxES4XExzyK8xw4PD2NovArLf7N3czQOCYfmSQTY rKYBaxYJPzPJ8brh2vTGOROLEbSr2z8RFOFxUlkEgTEGxlfn5+e3YX1bHBeOBjZc8hH76IoKME+Q nHLf1uyYtY+MXW7/R7wJIfHKnweERWD3QuNhcstjdUTUxpDYsp+gCNCiqQvqyPA3tMrYFAi7upyW 2z8VEkFYBHY3NN4UoTE6GPgSfdXG5Ck5AGg5kDZfr9gVBoeGxLZA2FdN/PTg4ODaXwh2g2sWgbbQ GE/+8YT/ZVimGtrcdY4A6x8/k4+ladMw3gt9edf2Ws+Q6v7/Css/BUXYLSqLQF9gvD07O3sd1nF5 Gpb9Od7LdYsAawXIIc9Noawm/juuhUQQFoH31NHRUTU0ZiMCY+8gNwBsJEROERLL9/gshMSXPm7Y XbqhAkND46uwnGXvptx4DA0bgEcrYXCbueWVdXn/P2F5ISjC7lNZBMYExtdnZ2d3YR2X+KXTs0HJ MCiue1FVBFjPmHkUVwaqiXMj1gbNaRrkJs7Jm4WQ+MrHDsIiQEpojA2Ju9DOiKHxA58MwCyBcAop o5w27fO/eHN4eCgkgrAIMDg03p2enr4pNgmMAHMmx4FDnDYEwr7wWPW5kAjvL9csApM4Pj5+W2nM 3k23cTPmNWrX5gDQkBUHJcR8dG//LwRFQGURmDowllXG8npGxxmAzctHBMt43eJpvB9C4o2PENCI A+YKjXkIjXH9pmiwON4AbE9QrF+nWIbEWx8fICwCmwyN5aanPhWANBN2ze8awCY+Pj86OhISgRWu WQQ2ERrjKnZLvS3WAEwnT3yuvt+5oAh0UVkENhkYy66p5bfcBrQBWD8odh5L4yA3tQFUL+JNCImv fXyAsAhsXWhcLpfVBo7QCDB/eLwSEgFhEdh6JycnZWisN3IA6AiDRaVw0RMUq9cmxvvXQiIwlGsW ga0IjXEp7gMwnWtBERhLZRHYlsAIwH191yN2Pf8q3hwfHxtUDBjNdUIAAFuq6Kr/pNZuW1S6oVbX 5f1bIRGYgm6oAABbamDPi5u4CIrAVHRDBQDYbmV306+6ncZRbirVxbfXI4aQ+MZHBUxJN1QAgC23 XC6buqLGCuJCSATmorIIALD96oPZ3IWQmGemHAJmpLIIAPAILJfLr9ptJycnQiIAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwFb4vwADAOmrOkDXB2s9AAAAAElF TkSuQmCC",
    transform: "matrix(0.6374 0 0 0.6374 -32.4408 22.6976)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 58.33,
    y: 38.53,
    width: 395.33,
    height: 434.95
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 58.33,
    y: 38.53,
    width: 395.33,
    height: 434.95,
    id: "SVGID_00000060014948419952329090000007790644512930070971_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000030469356496088828540000016777206221643297723_",
    filterUnits: "userSpaceOnUse",
    x: 58.33,
    y: 38.53,
    width: 395.33,
    height: 434.95
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 58.33,
    y: 38.53,
    width: 395.33,
    height: 434.95,
    id: "SVGID_00000060014948419952329090000007790644512930070971_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000108990614793954683880000007020937091755249577_",
    cx: 256,
    cy: 255.9998,
    r: 245.3263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7912,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9177,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000060014948419952329090000007790644512930070971_)",
      fill: "url(#SVGID_00000108990614793954683880000007020937091755249577_)"
    },
    d: " M418.85,121.78L290.81,47.86c-21.54-12.44-48.09-12.44-69.63,0L93.15,121.78c-21.54,12.44-34.81,35.42-34.81,60.3v147.84 c0,24.88,13.27,47.86,34.81,60.3l128.04,73.92c21.54,12.44,48.08,12.44,69.63,0l128.04-73.92c21.54-12.44,34.81-35.42,34.81-60.3 V182.08C453.67,157.2,440.39,134.22,418.85,121.78z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000108267787352579439410000006663798065815739571_",
    cx: 256,
    cy: 255.9998,
    r: 245.3263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7912,
    style: {
      stopColor: "#B5B5B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9177,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000108267787352579439410000006663798065815739571_)"
    },
    d: "M418.85,121.78L290.81,47.86 c-21.54-12.44-48.09-12.44-69.63,0L93.15,121.78c-21.54,12.44-34.81,35.42-34.81,60.3v147.84c0,24.88,13.27,47.86,34.81,60.3 l128.04,73.92c21.54,12.44,48.08,12.44,69.63,0l128.04-73.92c21.54-12.44,34.81-35.42,34.81-60.3V182.08 C453.67,157.2,440.39,134.22,418.85,121.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002383058105782070110000018293516054314332296_",
    cx: 256,
    cy: 603.4694,
    r: 305.4324,
    gradientTransform: "matrix(1 0 0 1.0918 0 -402.868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5949,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7731,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000002383058105782070110000018293516054314332296_)"
    },
    points: "504.93,193.96 233.17,193.96  120.12,193.96 7.07,193.96 40.74,252.37 7.07,318.04 120.12,318.04 233.17,318.04 504.93,318.04 471.26,252.37  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000180329149874049368930000014354685316336275335_",
    filterUnits: "userSpaceOnUse",
    x: 38.29,
    y: 193.96,
    width: 435.41,
    height: 124.08
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 38.29,
    y: 193.96,
    width: 435.41,
    height: 124.08,
    id: "SVGID_00000101822416628520633160000007078005729456665263_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000180329149874049368930000014354685316336275335_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000037673053259831224640000014210846813509900160_",
    filterUnits: "userSpaceOnUse",
    x: 38.29,
    y: 193.96,
    width: 435.41,
    height: 124.08
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 38.29,
    y: 193.96,
    width: 435.41,
    height: 124.08,
    id: "SVGID_00000101822416628520633160000007078005729456665263_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170991026067508706810000013992736566049943986_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.2943,
    y1: 255.9998,
    x2: 478.2209,
    y2: 255.9998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0302,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0838,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8839,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9654,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000101822416628520633160000007078005729456665263_)",
      fill: "url(#SVGID_00000170991026067508706810000013992736566049943986_)"
    },
    points: " 473.71,193.96 233.17,193.96 120.12,193.96 38.29,193.96 38.29,248.12 40.74,252.37 38.29,257.14 38.29,318.04 120.12,318.04  233.17,318.04 473.71,318.04 473.71,257.14 471.26,252.37 473.71,248.12  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109020632555344723110000007431847037535818938_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.2943,
    y1: 255.9998,
    x2: 478.2209,
    y2: 255.9998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0302,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0838,
    style: {
      stopColor: "#B5B5B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8839,
    style: {
      stopColor: "#B5B5B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9654,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109020632555344723110000007431847037535818938_)"
    },
    points: "473.71,193.96 233.17,193.96  120.12,193.96 38.29,193.96 38.29,248.12 40.74,252.37 38.29,257.14 38.29,318.04 120.12,318.04 233.17,318.04 473.71,318.04  473.71,257.14 471.26,252.37 473.71,248.12  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121970017156517574360000007732678702043094933_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.5651,
    y1: 255.9998,
    x2: 442.4343,
    y2: 255.9998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0824,
    style: {
      stopColor: "#007788"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    style: {
      stopColor: "#006C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#005A69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3792,
    style: {
      stopColor: "#00505D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    style: {
      stopColor: "#004C59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    style: {
      stopColor: "#00515E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7396,
    style: {
      stopColor: "#005F6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8829,
    style: {
      stopColor: "#007586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      stopColor: "#007788"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121970017156517574360000007732678702043094933_)"
    },
    d: "M409.6,129.4L288.84,59.68 c-20.32-11.73-45.35-11.73-65.67,0L102.4,129.4c-20.32,11.73-32.84,33.41-32.84,56.87v139.44c0,23.46,12.52,45.14,32.84,56.87 l120.76,69.72c20.32,11.73,45.35,11.73,65.67,0L409.6,382.6c20.32-11.73,32.84-33.41,32.84-56.87V186.28 C442.43,162.82,429.92,141.14,409.6,129.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000147936933433760588950000007881694847315163777_",
    cx: 256,
    cy: 255.9999,
    r: 198.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2142,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147936933433760588950000007881694847315163777_)"
    },
    d: "M256,463.84 c-11.83,0-23.66-3.05-34.21-9.14l-120.76-69.72c-21.1-12.19-34.21-34.89-34.21-59.26V186.28c0-24.36,13.11-47.07,34.21-59.25 L221.79,57.3c21.11-12.18,47.32-12.18,68.42,0l120.76,69.72c21.1,12.18,34.21,34.89,34.21,59.25v139.44 c0,24.37-13.11,47.07-34.21,59.26L290.21,454.7C279.66,460.79,267.83,463.84,256,463.84z M256,53.66c-10.88,0-21.76,2.8-31.46,8.4 l-120.76,69.72c-19.41,11.2-31.46,32.08-31.46,54.49v139.44c0,22.41,12.05,43.29,31.46,54.49l120.76,69.72 c19.41,11.2,43.52,11.2,62.92,0l120.76-69.72c19.41-11.2,31.46-32.09,31.46-54.49V186.28c0-22.41-12.05-43.29-31.46-54.49 L287.46,62.06C277.76,56.46,266.88,53.66,256,53.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158724519448088612940000005114667566784522389_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.4244,
    y1: 91.1334,
    x2: 375.9436,
    y2: 421.1254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158724519448088612940000005114667566784522389_)"
    },
    d: "M392.78,138.72c0.25,0,0.5-0.03,0.74-0.1 c0.73-0.2,1.34-0.67,1.72-1.32c0.38-0.66,0.48-1.42,0.28-2.16c-0.2-0.73-0.67-1.35-1.33-1.73c-1.36-0.78-3.1-0.32-3.89,1.04h0 c-0.78,1.36-0.31,3.1,1.05,3.89C391.8,138.59,392.29,138.72,392.78,138.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066474427174211041310000001571583882596559269_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.5712,
    y1: 90.493,
    x2: 365.0905,
    y2: 420.4814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066474427174211041310000001571583882596559269_)"
    },
    d: "M382.25,132.63 c0.98,0,1.94-0.51,2.47-1.42c0.38-0.66,0.48-1.42,0.28-2.16c-0.2-0.73-0.67-1.35-1.33-1.73c-0.66-0.38-1.43-0.48-2.16-0.29 c-0.74,0.2-1.35,0.67-1.73,1.33c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73 C381.28,132.51,381.77,132.63,382.25,132.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059990940048938343480000001525659010392826776_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.7184,
    y1: 89.8517,
    x2: 354.2375,
    y2: 419.844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059990940048938343480000001525659010392826776_)"
    },
    d: "M371.72,126.55 c0.98,0,1.94-0.51,2.47-1.42c0.78-1.36,0.31-3.1-1.05-3.89c-1.35-0.78-3.1-0.32-3.89,1.04h0c-0.78,1.36-0.31,3.1,1.05,3.89 C370.75,126.43,371.24,126.55,371.72,126.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080196401935349418560000005923920943128209057_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.8661,
    y1: 89.2103,
    x2: 343.3847,
    y2: 419.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080196401935349418560000005923920943128209057_)"
    },
    d: "M361.19,120.47 c0.25,0,0.49-0.03,0.74-0.1c0.74-0.2,1.35-0.67,1.73-1.33c0.38-0.66,0.48-1.42,0.28-2.16c-0.2-0.73-0.67-1.35-1.33-1.73 c-1.36-0.78-3.1-0.32-3.89,1.04h0c-0.78,1.36-0.31,3.1,1.05,3.89C360.21,120.35,360.69,120.47,361.19,120.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011006370382440892220000007868933390952178357_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.0128,
    y1: 88.5695,
    x2: 332.5312,
    y2: 418.5735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011006370382440892220000007868933390952178357_)"
    },
    d: "M350.66,114.39 c0.98,0,1.94-0.51,2.47-1.42c0.38-0.66,0.48-1.42,0.28-2.16c-0.2-0.73-0.67-1.35-1.33-1.73c-0.66-0.38-1.43-0.48-2.16-0.29 c-0.73,0.2-1.35,0.67-1.73,1.33c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73 C349.68,114.27,350.17,114.39,350.66,114.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156559241488399887860000014620299751870216361_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.1602,
    y1: 87.9288,
    x2: 321.6786,
    y2: 417.9331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156559241488399887860000014620299751870216361_)"
    },
    d: "M340.12,108.31 c0.98,0,1.94-0.51,2.47-1.42c0.78-1.36,0.31-3.1-1.04-3.88c-0.66-0.39-1.43-0.48-2.16-0.29c-0.73,0.2-1.35,0.67-1.73,1.32 c-0.78,1.36-0.31,3.1,1.05,3.89C339.15,108.19,339.64,108.31,340.12,108.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003081540478373293010000011883230223368094139_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.306,
    y1: 87.2883,
    x2: 310.8246,
    y2: 417.2891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003081540478373293010000011883230223368094139_)"
    },
    d: "M329.59,102.23 c0.25,0,0.49-0.03,0.74-0.1c0.73-0.2,1.35-0.66,1.73-1.32c0.78-1.36,0.31-3.1-1.05-3.89c-1.36-0.78-3.1-0.32-3.89,1.04 c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73C328.61,102.1,329.1,102.23,329.59,102.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019667461890856377280000007111136549267585947_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.4543,
    y1: 86.6477,
    x2: 299.9729,
    y2: 416.6485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019667461890856377280000007111136549267585947_)"
    },
    d: "M319.06,96.15c0.25,0,0.49-0.03,0.74-0.1 c0.74-0.2,1.35-0.67,1.73-1.33c0.38-0.66,0.48-1.42,0.28-2.16c-0.2-0.73-0.67-1.35-1.33-1.73c-1.36-0.78-3.1-0.32-3.89,1.04 c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73C318.08,96.02,318.57,96.15,319.06,96.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002350245642848545070000016657888940514186404_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.6009,
    y1: 86.0069,
    x2: 289.1193,
    y2: 416.0107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002350245642848545070000016657888940514186404_)"
    },
    d: "M308.53,90.07 c0.98,0,1.94-0.51,2.47-1.42c0.38-0.66,0.48-1.42,0.28-2.16c-0.2-0.73-0.67-1.35-1.33-1.73c-0.66-0.38-1.43-0.48-2.16-0.29 c-0.74,0.2-1.35,0.67-1.73,1.33c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73 C307.55,89.95,308.04,90.07,308.53,90.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085938327767399942510000012767193051128797631_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.7484,
    y1: 85.3663,
    x2: 278.267,
    y2: 415.3668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085938327767399942510000012767193051128797631_)"
    },
    d: "M298,83.99c0.98,0,1.94-0.51,2.47-1.42 c0.78-1.36,0.31-3.1-1.05-3.89c-1.36-0.78-3.1-0.32-3.89,1.04h0c-0.78,1.36-0.31,3.1,1.05,3.89 C297.02,83.87,297.51,83.99,298,83.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129199866732806996430000008387783813767709589_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.8976,
    y1: 84.7257,
    x2: 267.4163,
    y2: 414.7249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129199866732806996430000008387783813767709589_)"
    },
    d: "M287.47,77.91c0.25,0,0.5-0.03,0.74-0.1 c0.73-0.2,1.34-0.67,1.72-1.32c0.38-0.66,0.48-1.42,0.28-2.16c-0.2-0.73-0.67-1.35-1.32-1.72c-0.65-0.38-1.44-0.49-2.18-0.28 c-0.74,0.2-1.37,0.7-1.73,1.36c-0.75,1.36-0.28,3.05,1.07,3.85C286.48,77.78,286.97,77.91,287.47,77.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080894514751982530740000016101145590128642194_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.6624,
    y1: 84.0624,
    x2: 256.1812,
    y2: 414.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080894514751982530740000016101145590128642194_)"
    },
    d: "M275.52,72.56 c0.31,0.12,0.63,0.17,0.94,0.17c1.13,0,2.23-0.7,2.68-1.83c0.28-0.69,0.27-1.45-0.03-2.13c-0.31-0.72-0.91-1.27-1.65-1.55 c-0.72-0.29-1.51-0.26-2.21,0.07c-0.71,0.34-1.24,0.95-1.47,1.69C273.33,70.44,274.07,71.97,275.52,72.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154383984053268369800000003437876124858196888_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.7448,
    y1: 83.3591,
    x2: 244.2633,
    y2: 413.3631
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154383984053268369800000003437876124858196888_)"
    },
    d: "M264.72,69.79 c1.33,0,2.53-0.99,2.79-2.37c0.14-0.73-0.02-1.48-0.46-2.09c-0.45-0.64-1.14-1.07-1.92-1.2c-0.75-0.13-1.51,0.04-2.13,0.5 c-0.64,0.48-1.05,1.19-1.13,1.97c-0.15,1.5,0.87,2.85,2.41,3.15C264.43,69.78,264.58,69.79,264.72,69.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145748829781359743110000011781996541109213085_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.6209,
    y1: 82.6431,
    x2: 232.1398,
    y2: 412.6386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145748829781359743110000011781996541109213085_)"
    },
    d: "M252.6,69.25c0.04,0,0.08,0,0.12,0 c1.51-0.05,2.73-1.36,2.7-2.92c-0.01-0.75-0.32-1.44-0.86-1.96c-0.57-0.54-1.33-0.84-2.14-0.8c-0.78,0.03-1.49,0.38-2.01,0.97 c-0.51,0.58-0.76,1.36-0.68,2.11C249.89,68.15,251.11,69.25,252.6,69.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103981236323764790170000004803417333493647266_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.7775,
    y1: 81.9443,
    x2: 220.296,
    y2: 411.9467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103981236323764790170000004803417333493647266_)"
    },
    d: "M240.56,71.14c0.24,0,0.49-0.03,0.73-0.1 c1.48-0.34,2.41-1.86,2.07-3.39c-0.16-0.73-0.6-1.35-1.23-1.75c-0.66-0.42-1.46-0.55-2.28-0.36c-0.76,0.21-1.39,0.71-1.77,1.4 c-0.37,0.67-0.45,1.44-0.23,2.16C238.24,70.35,239.36,71.14,240.56,71.14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148622930978231047900000009178954918462044069_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.6926,
    y1: 81.2898,
    x2: 209.2111,
    y2: 411.2936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148622930978231047900000009178954918462044069_)"
    },
    d: "M229.22,75.39c0.42,0,0.84-0.1,1.22-0.3 c1.38-0.62,2-2.3,1.37-3.73c-0.3-0.68-0.85-1.2-1.55-1.47c-0.74-0.28-1.55-0.25-2.32,0.1c-0.71,0.38-1.23,1-1.45,1.76 c-0.22,0.72-0.14,1.48,0.22,2.13C227.23,74.84,228.22,75.39,229.22,75.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041267199106280928170000014882236060557533580_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.4806,
    y1: 80.6867,
    x2: 198.9999,
    y2: 410.676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041267199106280928170000014882236060557533580_)"
    },
    d: "M218.61,81.33 c0.48,0,0.97-0.12,1.42-0.38c1.36-0.78,1.83-2.53,1.05-3.89c-0.38-0.66-0.99-1.13-1.73-1.33c-0.74-0.19-1.5-0.09-2.16,0.29 c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16C216.67,80.82,217.63,81.33,218.61,81.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183930309855446321180000017323169887382229417_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.3439,
    y1: 80.0884,
    x2: 188.863,
    y2: 410.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183930309855446321180000017323169887382229417_)"
    },
    d: "M207.34,87.31 c0.24,0.06,0.49,0.1,0.74,0.1c0.49,0,0.98-0.13,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16 c-0.78-1.36-2.53-1.82-3.89-1.04c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16 C205.99,86.65,206.61,87.12,207.34,87.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163783844903702773600000013942241471602672540_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.2073,
    y1: 79.4902,
    x2: 178.7263,
    y2: 409.4829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163783844903702773600000013942241471602672540_)"
    },
    d: "M197.55,93.49 c0.48,0,0.97-0.12,1.42-0.38c0.66-0.38,1.13-1,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16c-0.78-1.36-2.53-1.82-3.89-1.04 c-1.36,0.78-1.83,2.53-1.05,3.89h0C195.61,92.98,196.57,93.49,197.55,93.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044138977507469277910000005453692692720877458_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.0679,
    y1: 78.8918,
    x2: 168.587,
    y2: 408.8842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044138977507469277910000005453692692720877458_)"
    },
    d: "M186.28,99.47 c0.24,0.07,0.49,0.1,0.74,0.1c0.49,0,0.98-0.13,1.42-0.38c1.36-0.78,1.83-2.53,1.04-3.89c-0.78-1.36-2.53-1.82-3.89-1.04 c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16C184.93,98.81,185.54,99.28,186.28,99.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116941011193343144990000006864053492738983869_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.9319,
    y1: 78.2928,
    x2: 158.4504,
    y2: 408.2946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116941011193343144990000006864053492738983869_)"
    },
    d: "M176.49,105.65 c0.48,0,0.97-0.12,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16c-0.78-1.36-2.53-1.82-3.89-1.04 c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16C174.54,105.14,175.5,105.65,176.49,105.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026132822630039607930000004289290287301492882_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.7931,
    y1: 77.6943,
    x2: 148.3118,
    y2: 407.6949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026132822630039607930000004289290287301492882_)"
    },
    d: "M165.21,111.63 c0.25,0.07,0.5,0.1,0.74,0.1c0.49,0,0.98-0.13,1.42-0.38c1.36-0.78,1.83-2.53,1.04-3.89c-0.78-1.36-2.53-1.82-3.89-1.04 c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16C163.86,110.97,164.48,111.44,165.21,111.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156551229438602425700000016840092653784119208_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.6566,
    y1: 77.0959,
    x2: 138.1752,
    y2: 407.0959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156551229438602425700000016840092653784119208_)"
    },
    d: "M155.42,117.81 c0.48,0,0.97-0.12,1.42-0.38c1.36-0.78,1.83-2.53,1.04-3.89c-0.78-1.36-2.53-1.82-3.89-1.04c-1.36,0.79-1.83,2.53-1.05,3.89h0 C153.48,117.3,154.44,117.81,155.42,117.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127030681211590330010000006302333068879825085_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.5193,
    y1: 76.4969,
    x2: 128.0377,
    y2: 406.5007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127030681211590330010000006302333068879825085_)"
    },
    d: "M144.89,123.89 c0.48,0,0.97-0.12,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16c-0.38-0.66-0.99-1.13-1.73-1.33 s-1.5-0.09-2.16,0.29c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16C142.95,123.38,143.91,123.89,144.89,123.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181051831655771552030000006778603032430592155_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.3816,
    y1: 75.8985,
    x2: 117.9001,
    y2: 405.9018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181051831655771552030000006778603032430592155_)"
    },
    d: "M133.62,129.88 c0.24,0.06,0.49,0.1,0.74,0.1c0.5,0,0.98-0.13,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16 c-0.38-0.66-0.99-1.13-1.73-1.32c-0.73-0.2-1.5-0.1-2.16,0.28c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16 C132.27,129.21,132.88,129.68,133.62,129.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094591248859067744120000008444170103803305658_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.2453,
    y1: 75.3006,
    x2: 107.7639,
    y2: 405.3009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094591248859067744120000008444170103803305658_)"
    },
    d: "M123.83,136.05 c0.48,0,0.97-0.12,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16c-0.78-1.36-2.53-1.82-3.89-1.04 c-1.36,0.78-1.83,2.53-1.05,3.89h0C121.88,135.55,122.84,136.05,123.83,136.05z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145018818985587258370000004250569243212164770_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.1075,
    y1: 74.7025,
    x2: 97.6264,
    y2: 404.6988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145018818985587258370000004250569243212164770_)"
    },
    d: "M113.33,142.15c0.5,0,1-0.13,1.45-0.41 c1.31-0.84,1.75-2.58,0.98-3.89c-0.4-0.67-1.06-1.16-1.8-1.34c-0.72-0.17-1.48-0.05-2.11,0.36c-0.68,0.42-1.15,1.08-1.33,1.85 c-0.16,0.73-0.03,1.48,0.38,2.11C111.45,141.68,112.39,142.15,113.33,142.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168812042303017571910000006755630200439194771_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.7999,
    y1: 74.1527,
    x2: 88.3185,
    y2: 404.1531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168812042303017571910000006755630200439194771_)"
    },
    d: "M103.56,149.36 c0.69,0,1.38-0.25,1.91-0.75c1.09-1.09,1.19-2.78,0.23-3.94c-0.5-0.6-1.24-0.97-2.04-1c-0.76-0.04-1.51,0.24-2.04,0.76 c-0.59,0.55-0.92,1.29-0.94,2.08c-0.01,0.75,0.27,1.46,0.79,1.99C102.05,149.07,102.81,149.36,103.56,149.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047774284110315378320000000230889798522349973_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.2304,
    y1: 73.7081,
    x2: 80.7497,
    y2: 403.6974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047774284110315378320000000230889798522349973_)"
    },
    d: "M95.41,158.36c0.89,0,1.76-0.4,2.31-1.16 c0.87-1.28,0.62-2.96-0.57-3.92c-0.61-0.48-1.4-0.69-2.17-0.58c-0.77,0.12-1.43,0.53-1.86,1.16c-0.47,0.66-0.65,1.44-0.51,2.21 c0.13,0.74,0.55,1.37,1.17,1.79C94.28,158.2,94.85,158.36,95.41,158.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116916170239656140480000000646635527281062024_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.6933,
    y1: 73.3812,
    x2: 75.2125,
    y2: 403.3719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116916170239656140480000000646635527281062024_)"
    },
    d: "M88.08,168.59L88.08,168.59 c0.37,0.15,0.75,0.22,1.13,0.22c1.1,0,2.15-0.62,2.62-1.65c0.6-1.4,0.01-3.04-1.34-3.74c-0.68-0.36-1.49-0.41-2.21-0.15 c-0.73,0.26-1.31,0.8-1.62,1.52c-0.33,0.74-0.36,1.54-0.07,2.27C86.86,167.76,87.39,168.3,88.08,168.59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035526485126623846180000011854520994420908195_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.4158,
    y1: 73.1857,
    x2: 71.9345,
    y2: 403.1839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035526485126623846180000011854520994420908195_)"
    },
    d: "M84.64,180.23 c0.19,0.04,0.38,0.06,0.56,0.06c1.32,0,2.53-0.89,2.83-2.18c0.34-1.46-0.59-2.99-2.07-3.41c-0.74-0.21-1.49-0.11-2.14,0.27 c-0.67,0.4-1.14,1.05-1.32,1.83c-0.18,0.78-0.05,1.58,0.37,2.24C83.28,179.67,83.9,180.09,84.64,180.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089542804904183035630000015259608088666984618_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.5198,
    y1: 73.1307,
    x2: 71.0381,
    y2: 403.1354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089542804904183035630000015259608088666984618_)"
    },
    d: "M83.56,192.33c0.01,0,0.02,0,0.03,0 c1.55-0.01,2.86-1.25,2.9-2.75c0.05-1.5-1.16-2.82-2.71-2.94c-0.77-0.05-1.47,0.18-2.03,0.68c-0.58,0.52-0.92,1.25-0.95,2.07 c-0.03,0.81,0.26,1.56,0.81,2.12C82.13,192.04,82.82,192.33,83.56,192.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073690622630773441150000012803747043412369322_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.1675,
    y1: 73.1704,
    x2: 71.6862,
    y2: 403.1707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073690622630773441150000012803747043412369322_)"
    },
    d: "M83.58,204.49 c1.57,0,2.84-1.28,2.84-2.85c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,203.21,82.02,204.49,83.58,204.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152242226161507441880000017619409798180182181_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.8829,
    y1: 73.2119,
    x2: 72.4015,
    y2: 403.2137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152242226161507441880000017619409798180182181_)"
    },
    d: "M83.58,216.65 c1.57,0,2.84-1.28,2.84-2.85s-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85S82.02,216.65,83.58,216.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000937228356339819750000011092167219670059151_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5984,
    y1: 73.2549,
    x2: 73.117,
    y2: 403.2551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000937228356339819750000011092167219670059151_)"
    },
    d: "M83.58,228.81 c1.57,0,2.84-1.28,2.84-2.85c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,227.53,82.02,228.81,83.58,228.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062871997702067074270000007256197395155285136_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.3133,
    y1: 73.3045,
    x2: 73.8328,
    y2: 403.2894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062871997702067074270000007256197395155285136_)"
    },
    d: "M83.58,240.97 c1.57,0,2.84-1.28,2.84-2.85c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,239.7,82.02,240.97,83.58,240.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157992293308320311850000015070358557452801436_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.0292,
    y1: 73.339,
    x2: 74.5479,
    y2: 403.3393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157992293308320311850000015070358557452801436_)"
    },
    d: "M83.58,253.13 c1.57,0,2.84-1.28,2.84-2.85c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,251.86,82.02,253.13,83.58,253.13z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005967980522064742590000007116848535956765580_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.7446,
    y1: 73.3811,
    x2: 75.2632,
    y2: 403.3814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005967980522064742590000007116848535956765580_)"
    },
    d: "M83.58,265.3c1.57,0,2.84-1.28,2.84-2.85 c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,264.02,82.02,265.3,83.58,265.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125589636271689793410000004146045986738456726_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.4601,
    y1: 73.4234,
    x2: 75.9787,
    y2: 403.4237
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125589636271689793410000004146045986738456726_)"
    },
    d: "M83.58,277.46 c1.57,0,2.84-1.28,2.84-2.85c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,276.18,82.02,277.46,83.58,277.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127766096142495789680000014055515389231964597_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.1754,
    y1: 73.4655,
    x2: 76.6941,
    y2: 403.4658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127766096142495789680000014055515389231964597_)"
    },
    d: "M83.58,289.62 c1.57,0,2.84-1.28,2.84-2.85c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,288.34,82.02,289.62,83.58,289.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116918072044436368060000004997875200776584875_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.8909,
    y1: 73.5078,
    x2: 77.4096,
    y2: 403.5081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116918072044436368060000004997875200776584875_)"
    },
    d: "M83.58,301.78 c1.57,0,2.84-1.28,2.84-2.85c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,300.5,82.02,301.78,83.58,301.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023962508860642823790000006825874315390272646_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.6063,
    y1: 73.5499,
    x2: 78.1249,
    y2: 403.5502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023962508860642823790000006825874315390272646_)"
    },
    d: "M83.58,313.94 c1.57,0,2.84-1.28,2.84-2.85c0-1.57-1.27-2.85-2.84-2.85c-1.57,0-2.84,1.28-2.84,2.85C80.74,312.66,82.02,313.94,83.58,313.94z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158016870890584616270000004267201065400518294_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.4112,
    y1: 73.5983,
    x2: 78.9298,
    y2: 403.598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158016870890584616270000004267201065400518294_)"
    },
    d: "M83.87,326.09 c1.53-0.13,2.67-1.4,2.65-2.96c-0.05-1.51-1.35-2.73-2.91-2.73c0,0-0.01,0-0.01,0c-0.75,0-1.44,0.3-1.96,0.84 c-0.55,0.57-0.83,1.32-0.8,2.11c0.01,0.78,0.33,1.5,0.91,2.02c0.52,0.47,1.19,0.72,1.88,0.72 C83.71,326.1,83.79,326.1,83.87,326.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002354027686524629340000004863413372252956549_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.8662,
    y1: 73.7418,
    x2: 81.3847,
    y2: 403.7433
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002354027686524629340000004863413372252956549_)"
    },
    d: "M88.2,334.58 c-0.35-1.47-1.87-2.41-3.39-2.1c-0.73,0.15-1.35,0.58-1.76,1.22c-0.42,0.66-0.55,1.46-0.37,2.23c0.16,0.76,0.62,1.39,1.29,1.79 c0.44,0.27,0.95,0.4,1.45,0.4c0.26,0,0.53-0.04,0.78-0.11C87.66,337.57,88.52,336.11,88.2,334.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115500679130271289620000004527434537868158102_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.6376,
    y1: 74.0294,
    x2: 86.1566,
    y2: 404.0235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115500679130271289620000004527434537868158102_)"
    },
    d: "M88.39,344.08 c-0.69,0.29-1.21,0.84-1.49,1.54c-0.28,0.73-0.26,1.54,0.07,2.26c0.31,0.7,0.88,1.23,1.62,1.49c0.31,0.11,0.63,0.16,0.94,0.16 c0.46,0,0.91-0.11,1.31-0.32h0c1.34-0.71,1.89-2.32,1.27-3.75C91.5,344.09,89.82,343.47,88.39,344.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116213110296664078900000013739847877575598237_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.5383,
    y1: 74.4335,
    x2: 93.0571,
    y2: 404.4312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116213110296664078900000013739847877575598237_)"
    },
    d: "M94.21,354.73 c-0.61,0.43-1.02,1.07-1.15,1.8c-0.13,0.78,0.05,1.56,0.53,2.23c0.47,0.63,1.16,1.03,1.94,1.12c0.11,0.01,0.22,0.02,0.34,0.02 c0.65,0,1.28-0.22,1.78-0.63c1.19-0.98,1.4-2.7,0.5-3.92C97.25,354.12,95.49,353.84,94.21,354.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024695338332473325540000012757598741119858565_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.2781,
    y1: 74.9424,
    x2: 101.7963,
    y2: 404.9488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024695338332473325540000012757598741119858565_)"
    },
    d: "M102.03,364.01 c-0.52,0.54-0.79,1.25-0.77,2c0.02,0.79,0.35,1.52,0.97,2.1c0.54,0.46,1.2,0.7,1.89,0.7c0.09,0,0.18,0,0.28-0.01 c0.76-0.07,1.43-0.43,1.9-1.02c0.98-1.21,0.83-2.98-0.3-3.93C104.89,362.82,103.11,362.89,102.03,364.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055670648976940062960000018009107910852358543_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.5149,
    y1: 75.5449,
    x2: 112.0331,
    y2: 405.5522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055670648976940062960000018009107910852358543_)"
    },
    d: "M115.39,370.62 c-1.29-0.81-3.02-0.39-3.86,0.94c-0.4,0.63-0.52,1.38-0.36,2.12c0.18,0.77,0.65,1.42,1.35,1.86c0.45,0.26,0.94,0.38,1.42,0.38 c0.98,0,1.94-0.51,2.47-1.42h0C117.2,373.13,116.73,371.39,115.39,370.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177457742092793876130000002353881221881087113_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.3665,
    y1: 76.1991,
    x2: 122.8855,
    y2: 406.1918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177457742092793876130000002353881221881087113_)"
    },
    d: "M125.9,376.68 c-1.36-0.78-3.1-0.32-3.89,1.04c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73c0.44,0.25,0.93,0.38,1.42,0.38 c0.25,0,0.49-0.03,0.74-0.1c0.74-0.2,1.35-0.67,1.73-1.33c0.38-0.66,0.48-1.42,0.28-2.16 C127.03,377.68,126.56,377.06,125.9,376.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173878743209843112620000007383023763486094742_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.2192,
    y1: 76.8388,
    x2: 133.7382,
    y2: 406.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173878743209843112620000007383023763486094742_)"
    },
    d: "M136.43,382.76 c-0.66-0.38-1.42-0.49-2.16-0.28c-0.73,0.2-1.35,0.67-1.73,1.32c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73 c0.44,0.25,0.93,0.38,1.42,0.38c0.25,0,0.49-0.03,0.74-0.1c0.74-0.2,1.35-0.67,1.73-1.33c0.38-0.66,0.48-1.42,0.28-2.16 C137.56,383.76,137.09,383.14,136.43,382.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052794439698632078860000005262926454224783277_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.0719,
    y1: 77.4812,
    x2: 144.591,
    y2: 407.4736
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052794439698632078860000005262926454224783277_)"
    },
    d: "M146.97,388.84 c-1.36-0.78-3.1-0.32-3.89,1.04c-0.78,1.36-0.31,3.1,1.05,3.89c0.45,0.26,0.94,0.38,1.42,0.38c0.98,0,1.94-0.51,2.47-1.42h0 C148.8,391.37,148.33,389.63,146.97,388.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179604824515281626770000017797959830018048701_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.9245,
    y1: 78.126,
    x2: 155.4438,
    y2: 408.1142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179604824515281626770000017797959830018048701_)"
    },
    d: "M157.5,394.93 c-0.66-0.38-1.42-0.48-2.16-0.29c-0.74,0.2-1.35,0.67-1.73,1.33c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73 c0.44,0.25,0.93,0.38,1.42,0.38c0.25,0,0.5-0.03,0.74-0.1c0.74-0.2,1.35-0.66,1.73-1.32c0.38-0.66,0.48-1.42,0.28-2.16 C158.63,395.92,158.16,395.31,157.5,394.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139986589883260853830000000106842700895552401_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.7781,
    y1: 78.7625,
    x2: 166.2972,
    y2: 408.7548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139986589883260853830000000106842700895552401_)"
    },
    d: "M168.03,401.01 c-1.36-0.78-3.1-0.32-3.89,1.04c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73c0.44,0.25,0.93,0.38,1.42,0.38 c0.25,0,0.49-0.03,0.74-0.1c0.74-0.2,1.35-0.67,1.73-1.33c0.38-0.66,0.48-1.42,0.28-2.16C169.16,402,168.69,401.39,168.03,401.01z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024721706315377510730000002041402902889317276_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.6301,
    y1: 79.3973,
    x2: 177.1489,
    y2: 409.3957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024721706315377510730000002041402902889317276_)"
    },
    d: "M178.56,407.08 c-1.36-0.78-3.1-0.32-3.89,1.04c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73c0.45,0.26,0.94,0.38,1.42,0.38 c0.98,0,1.94-0.51,2.47-1.42h0C180.39,409.61,179.92,407.87,178.56,407.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069357850627141866090000007640026257779201214_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.4839,
    y1: 80.0355,
    x2: 188.0025,
    y2: 410.0362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069357850627141866090000007640026257779201214_)"
    },
    d: "M189.09,413.16 c-1.36-0.78-3.1-0.32-3.89,1.04c-0.78,1.36-0.31,3.1,1.05,3.89c0.45,0.26,0.94,0.38,1.42,0.38c0.98,0,1.94-0.51,2.47-1.42h0 C190.92,415.69,190.45,413.95,189.09,413.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116915782997256979410000008631480708889958820_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.3374,
    y1: 80.673,
    x2: 198.8559,
    y2: 410.6765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116915782997256979410000008631480708889958820_)"
    },
    d: "M199.63,419.25 c-0.66-0.38-1.43-0.48-2.16-0.29c-0.74,0.2-1.35,0.67-1.73,1.33c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73 c0.45,0.26,0.94,0.38,1.42,0.38c0.98,0,1.94-0.51,2.47-1.42c0.38-0.66,0.48-1.42,0.28-2.16 C200.76,420.24,200.28,419.63,199.63,419.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124881314389894868300000015963388435825574543_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.1904,
    y1: 81.3176,
    x2: 209.709,
    y2: 411.3174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124881314389894868300000015963388435825574543_)"
    },
    d: "M210.16,425.33 c-1.36-0.78-3.11-0.32-3.89,1.04c-0.78,1.36-0.31,3.1,1.05,3.89c0.44,0.25,0.93,0.38,1.42,0.38c0.25,0,0.5-0.03,0.74-0.1 c0.73-0.2,1.34-0.67,1.72-1.32c0.38-0.66,0.48-1.42,0.28-2.16C211.29,426.32,210.82,425.71,210.16,425.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024686759838418340190000014324029884070670209_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.042,
    y1: 81.9565,
    x2: 220.5605,
    y2: 411.9586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024686759838418340190000014324029884070670209_)"
    },
    d: "M220.69,431.41 c-1.36-0.78-3.1-0.32-3.89,1.04c-0.38,0.66-0.48,1.42-0.28,2.16c0.2,0.73,0.67,1.35,1.33,1.73c0.45,0.26,0.94,0.38,1.42,0.38 c0.98,0,1.94-0.51,2.47-1.42h0C222.52,433.94,222.05,432.19,220.69,431.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106138781304575231500000006511018093191517884_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.9746,
    y1: 82.6087,
    x2: 231.4936,
    y2: 412.6041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106138781304575231500000006511018093191517884_)"
    },
    d: "M231.1,437.19 c-1.42-0.61-3.03-0.06-3.73,1.28c-0.36,0.69-0.42,1.51-0.16,2.26c0.26,0.74,0.79,1.31,1.48,1.61c0.4,0.18,0.81,0.27,1.23,0.27 c0.35,0,0.71-0.06,1.04-0.2c0.7-0.27,1.25-0.8,1.54-1.49C233.11,439.49,232.49,437.81,231.1,437.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160891124012421864090000016225780189446439048_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.6059,
    y1: 83.2921,
    x2: 243.1247,
    y2: 413.2901
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160891124012421864090000016225780189446439048_)"
    },
    d: "M241.98,441.09 c-1.53-0.31-2.98,0.56-3.4,2.01c-0.22,0.74-0.11,1.56,0.29,2.24c0.4,0.67,1.04,1.12,1.77,1.27c0.23,0.05,0.46,0.08,0.69,0.08 c0.55,0,1.09-0.16,1.56-0.46c0.63-0.4,1.06-1.03,1.21-1.76C244.42,442.96,243.47,441.44,241.98,441.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046302194079516861770000018077503862347288489_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.6875,
    y1: 84.0099,
    x2: 255.2065,
    y2: 414.004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046302194079516861770000018077503862347288489_)"
    },
    d: "M253.44,442.75 c-1.58-0.03-2.81,1.13-2.94,2.65c-0.07,0.77,0.2,1.54,0.72,2.12c0.52,0.58,1.24,0.9,2,0.91c0.04,0,0.07,0,0.11,0 c0.77,0,1.48-0.28,2.02-0.81c0.54-0.52,0.84-1.22,0.84-1.96C256.19,444.11,254.97,442.81,253.44,442.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077291271805358783780000006672453358736538789_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.7364,
    y1: 84.7086,
    x2: 267.2547,
    y2: 414.7144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077291271805358783780000006672453358736538789_)"
    },
    d: "M265,442.1c-1.5,0.27-2.54,1.67-2.36,3.2 c0.09,0.77,0.48,1.45,1.09,1.91c0.49,0.36,1.07,0.55,1.67,0.55c0.17,0,0.34-0.01,0.5-0.04c0.8-0.13,1.48-0.55,1.93-1.2 c0.43-0.62,0.58-1.36,0.43-2.09v0C267.96,442.9,266.49,441.85,265,442.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096756094420911857320000012628850831145768327_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.2639,
    y1: 85.3996,
    x2: 278.7828,
    y2: 415.3957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096756094420911857320000012628850831145768327_)"
    },
    d: "M276.2,439.16 c-1.41,0.53-2.17,2.15-1.69,3.62c0.23,0.72,0.74,1.3,1.41,1.62c0.38,0.18,0.8,0.28,1.22,0.28c0.35,0,0.7-0.06,1.05-0.19 c0.76-0.29,1.35-0.84,1.66-1.56c0.29-0.69,0.3-1.44,0-2.13C279.25,439.37,277.61,438.64,276.2,439.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104691406298382052770000001600777305339917194_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.814,
    y1: 86.0284,
    x2: 289.3332,
    y2: 416.0191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104691406298382052770000001600777305339917194_)"
    },
    d: "M288.86,433.78 c-0.74-0.19-1.5-0.09-2.16,0.29c-0.66,0.38-1.13,0.99-1.33,1.72c-0.2,0.73-0.1,1.5,0.28,2.16c0.53,0.91,1.48,1.42,2.47,1.42 c0.48,0,0.97-0.12,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16 C290.21,434.45,289.59,433.98,288.86,433.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180366275730761967300000004163360382147782795_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.9506,
    y1: 86.6222,
    x2: 299.4695,
    y2: 416.6167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180366275730761967300000004163360382147782795_)"
    },
    d: "M301.12,429.03 c-0.78-1.35-2.53-1.81-3.89-1.04c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.74-0.1,1.5,0.28,2.16c0.53,0.91,1.48,1.42,2.47,1.42 c0.48,0,0.97-0.12,1.42-0.38C301.43,432.13,301.9,430.39,301.12,429.03L301.12,429.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049185598843095590860000001556771984753797259_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.0912,
    y1: 87.2085,
    x2: 309.6095,
    y2: 417.2153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049185598843095590860000001556771984753797259_)"
    },
    d: "M307.76,421.91 c-1.36,0.78-1.83,2.53-1.04,3.89c0.52,0.91,1.48,1.42,2.47,1.42c0.48,0,0.97-0.12,1.42-0.38c0.66-0.38,1.13-1,1.33-1.73 c0.2-0.73,0.1-1.5-0.28-2.16C310.87,421.59,309.12,421.13,307.76,421.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080891061273831293540000000937163772052410512_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.2268,
    y1: 87.8132,
    x2: 319.7455,
    y2: 417.8138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080891061273831293540000000937163772052410512_)"
    },
    d: "M318.3,415.83 c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16c0.38,0.66,1,1.13,1.73,1.33c0.24,0.06,0.49,0.1,0.74,0.1 c0.49,0,0.98-0.13,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16C321.4,415.51,319.66,415.05,318.3,415.83z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161592464243923905100000015689771481837286585_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.3655,
    y1: 88.4088,
    x2: 329.8839,
    y2: 418.4123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161592464243923905100000015689771481837286585_)"
    },
    d: "M330.99,409.46 c-0.73-0.2-1.5-0.1-2.16,0.29c-1.36,0.78-1.83,2.53-1.04,3.89c0.53,0.91,1.48,1.42,2.47,1.42c0.48,0,0.97-0.12,1.42-0.38 c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16C332.34,410.13,331.72,409.66,330.99,409.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134932646951521544200000013136444032068547230_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.5012,
    y1: 89.0103,
    x2: 340.0198,
    y2: 419.0111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134932646951521544200000013136444032068547230_)"
    },
    d: "M343.25,404.7 c-0.78-1.36-2.53-1.82-3.89-1.04c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16c0.53,0.91,1.48,1.42,2.47,1.42 c0.48,0,0.97-0.12,1.42-0.38C343.56,407.81,344.03,406.06,343.25,404.7L343.25,404.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066515969985455274190000016094153946697153211_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.6392,
    y1: 89.6087,
    x2: 350.1578,
    y2: 419.609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066515969985455274190000016094153946697153211_)"
    },
    d: "M349.89,397.58 c-1.36,0.79-1.83,2.53-1.04,3.89c0.53,0.91,1.48,1.42,2.47,1.42c0.48,0,0.97-0.12,1.42-0.38c1.36-0.79,1.83-2.53,1.04-3.89 C353,397.27,351.25,396.81,349.89,397.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107556378072193537480000009683919600964612487_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.7769,
    y1: 90.2074,
    x2: 360.2955,
    y2: 420.2079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107556378072193537480000009683919600964612487_)"
    },
    d: "M360.42,391.5 c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16c0.38,0.66,0.99,1.13,1.73,1.33c0.24,0.06,0.49,0.1,0.74,0.1 c0.49,0,0.98-0.13,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16C363.53,391.19,361.78,390.73,360.42,391.5 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044139997733592850420000018191243160331353505_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.9147,
    y1: 90.8017,
    x2: 370.4331,
    y2: 420.8065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044139997733592850420000018191243160331353505_)"
    },
    d: "M373.11,385.14 c-0.73-0.19-1.5-0.09-2.16,0.29c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16c0.53,0.91,1.48,1.42,2.47,1.42 c0.48,0,0.97-0.12,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73c0.2-0.73,0.1-1.5-0.28-2.16 C374.46,385.81,373.85,385.33,373.11,385.14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037663311655602642280000009595886454282787755_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.0512,
    y1: 91.404,
    x2: 380.5698,
    y2: 421.4045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037663311655602642280000009595886454282787755_)"
    },
    d: "M385.37,380.38 c-0.78-1.36-2.53-1.82-3.89-1.04c-0.66,0.38-1.13,0.99-1.33,1.73c-0.2,0.73-0.1,1.5,0.28,2.16c0.52,0.91,1.48,1.42,2.47,1.42 c0.48,0,0.97-0.12,1.42-0.38C385.69,383.48,386.16,381.74,385.37,380.38L385.37,380.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111898097527767111550000011812200356385933188_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.1904,
    y1: 92.0018,
    x2: 390.709,
    y2: 422.0034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111898097527767111550000011812200356385933188_)"
    },
    d: "M392.02,373.26 c-1.36,0.78-1.83,2.53-1.04,3.89c0.53,0.91,1.48,1.42,2.47,1.42c0.48,0,0.97-0.12,1.42-0.38c0.66-0.38,1.13-0.99,1.33-1.73 c0.2-0.73,0.1-1.5-0.28-2.16C395.12,372.94,393.38,372.49,392.02,373.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157278414559577862300000009900764497202249656_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.108,
    y1: 92.5837,
    x2: 400.6263,
    y2: 422.5892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157278414559577862300000009900764497202249656_)"
    },
    d: "M402.07,367 c-1.23,0.88-1.52,2.65-0.64,3.94c0.42,0.62,1.05,1.03,1.79,1.16c0.17,0.03,0.34,0.05,0.5,0.05c0.6,0,1.19-0.19,1.7-0.55 c0.64-0.44,1.06-1.11,1.17-1.88c0.11-0.77-0.1-1.56-0.59-2.16C405.04,366.37,403.36,366.12,402.07,367z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093174912041856948820000001502260338331640741_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.5876,
    y1: 93.0868,
    x2: 409.106,
    y2: 423.0902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093174912041856948820000001502260338331640741_)"
    },
    d: "M410.64,359.23 c-1.03,1.11-0.97,2.89,0.15,3.99c0.52,0.51,1.2,0.78,1.93,0.78c0.02,0,0.04,0,0.06,0c0.78-0.02,1.52-0.35,2.06-0.93 c0.54-0.55,0.81-1.29,0.77-2.06c-0.04-0.79-0.41-1.53-1.01-2.02C413.44,358.02,411.74,358.12,410.64,359.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116919930987475303720000015690685377755863939_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.1751,
    y1: 93.4763,
    x2: 415.6936,
    y2: 423.4784
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116919930987475303720000015690685377755863939_)"
    },
    d: "M421.32,348.88 c-1.35-0.73-2.99-0.29-3.82,1.03c-0.8,1.29-0.39,3.02,0.93,3.87c0.45,0.29,0.96,0.44,1.49,0.44c0.21,0,0.41-0.02,0.62-0.07 c0.77-0.17,1.42-0.64,1.84-1.32c0.41-0.66,0.53-1.43,0.33-2.19C422.51,349.89,422,349.25,421.32,348.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163792311983842851830000016888860037790621580_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.6106,
    y1: 93.7422,
    x2: 420.1294,
    y2: 423.7395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163792311983842851830000016888860037790621580_)"
    },
    d: "M425.9,337.64 c-1.49-0.45-3.04,0.34-3.53,1.77c-0.54,1.42,0.21,3.04,1.66,3.61c0.33,0.13,0.67,0.2,1.01,0.2c0.38,0,0.77-0.08,1.13-0.24 c0.72-0.32,1.27-0.91,1.57-1.69c0.25-0.75,0.19-1.55-0.17-2.24C427.23,338.36,426.63,337.86,425.9,337.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164492063320606792850000004250017283316754567_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.7261,
    y1: 93.8598,
    x2: 422.2443,
    y2: 423.8672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164492063320606792850000004250017283316754567_)"
    },
    d: "M428.16,325.72L428.16,325.72 c-1.54-0.14-2.94,0.97-3.09,2.43c-0.25,1.49,0.8,2.94,2.34,3.21c0.16,0.03,0.32,0.04,0.49,0.04c0.57,0,1.12-0.18,1.6-0.51 c0.64-0.45,1.07-1.14,1.21-1.98c0.08-0.8-0.14-1.57-0.65-2.18C429.57,326.15,428.9,325.79,428.16,325.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083072299733063531160000017948517857539421087_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.5555,
    y1: 93.8548,
    x2: 422.0741,
    y2: 423.8551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083072299733063531160000017948517857539421087_)"
    },
    d: "M428.42,313.57 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,314.84,429.98,313.57,428.42,313.57z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022545068402367567830000002804258106577272227_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.8401,
    y1: 93.8119,
    x2: 421.3586,
    y2: 423.8138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022545068402367567830000002804258106577272227_)"
    },
    d: "M428.42,301.41 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,302.68,429.98,301.41,428.42,301.41z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119101251061254210570000004038882680688081582_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.1245,
    y1: 93.7704,
    x2: 420.6432,
    y2: 423.7707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119101251061254210570000004038882680688081582_)"
    },
    d: "M428.42,289.24 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,290.52,429.98,289.24,428.42,289.24z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145019384302703879570000001934264210277912758_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.4092,
    y1: 93.7276,
    x2: 419.9278,
    y2: 423.7295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145019384302703879570000001934264210277912758_)"
    },
    d: "M428.42,277.08 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,278.36,429.98,277.08,428.42,277.08z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141427402052183326430000000257827434337839273_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.6937,
    y1: 93.686,
    x2: 419.2123,
    y2: 423.6862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141427402052183326430000000257827434337839273_)"
    },
    d: "M428.42,264.92 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,266.2,429.98,264.92,428.42,264.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090992234622842514610000002784535675678600601_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.9783,
    y1: 93.6439,
    x2: 418.4969,
    y2: 423.6441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090992234622842514610000002784535675678600601_)"
    },
    d: "M428.42,252.76 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,254.04,429.98,252.76,428.42,252.76z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172434612732957869200000011246122933857106855_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.2628,
    y1: 93.6018,
    x2: 417.7815,
    y2: 423.6021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172434612732957869200000011246122933857106855_)"
    },
    d: "M428.42,240.6 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,241.88,429.98,240.6,428.42,240.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021104027626420002140000008490072762394163091_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.5475,
    y1: 93.5597,
    x2: 417.0661,
    y2: 423.56
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021104027626420002140000008490072762394163091_)"
    },
    d: "M428.42,228.44 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,229.72,429.98,228.44,428.42,228.44z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040534647632342185640000007648442229655602838_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.832,
    y1: 93.5174,
    x2: 416.3506,
    y2: 423.5177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040534647632342185640000007648442229655602838_)"
    },
    d: "M428.42,216.28 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,217.56,429.98,216.28,428.42,216.28z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183952340172456752720000016372275902428940698_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.1166,
    y1: 93.4753,
    x2: 415.6352,
    y2: 423.4756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183952340172456752720000016372275902428940698_)"
    },
    d: "M428.42,204.12 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,205.39,429.98,204.12,428.42,204.12z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019652452811338454490000001818593574193315755_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.4011,
    y1: 93.433,
    x2: 414.9198,
    y2: 423.4333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019652452811338454490000001818593574193315755_)"
    },
    d: "M428.42,191.96 c-1.57,0-2.84,1.28-2.84,2.85c0,1.57,1.27,2.85,2.84,2.85c1.57,0,2.84-1.28,2.84-2.85C431.26,193.23,429.98,191.96,428.42,191.96z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163072300381561217720000004667864672992169912_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.0308,
    y1: 93.354,
    x2: 413.5498,
    y2: 423.3475
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163072300381561217720000004667864672992169912_)"
    },
    d: "M424.94,183.12 c0.27,1.41,1.47,2.4,2.84,2.4c0.1,0,0.2-0.01,0.3-0.02c0.77-0.08,1.49-0.49,1.97-1.13c0.47-0.63,0.65-1.38,0.51-2.12 c-0.13-0.8-0.56-1.48-1.21-1.93c-0.62-0.43-1.36-0.58-2.09-0.45C425.73,180.16,424.69,181.61,424.94,183.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140728097151137483560000013452287961495301252_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.3937,
    y1: 93.1378,
    x2: 409.9124,
    y2: 423.1362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140728097151137483560000013452287961495301252_)"
    },
    d: "M422.12,171.9 c0.47,1.14,1.54,1.84,2.7,1.84c0.29,0,0.58-0.04,0.87-0.13c0.74-0.23,1.36-0.77,1.69-1.49c0.33-0.7,0.36-1.49,0.07-2.19 c-0.29-0.76-0.84-1.34-1.56-1.66c-0.68-0.3-1.44-0.31-2.13-0.02C422.32,168.84,421.58,170.46,422.12,171.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040538490700782429530000006772438706567218859_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.531,
    y1: 92.7905,
    x2: 404.0494,
    y2: 422.7942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040538490700782429530000006772438706567218859_)"
    },
    d: "M419.58,162.78 c0.48,0,0.95-0.12,1.39-0.36c0.68-0.37,1.17-1.01,1.36-1.76c0.19-0.76,0.06-1.54-0.36-2.19c-0.43-0.69-1.08-1.15-1.85-1.32 c-0.73-0.16-1.48-0.02-2.1,0.4c-1.3,0.87-1.7,2.61-0.9,3.9C417.68,162.31,418.62,162.78,419.58,162.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069362553996871852510000015218717864395125939_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.6793,
    y1: 92.3269,
    x2: 396.1975,
    y2: 422.3331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069362553996871852510000015218717864395125939_)"
    },
    d: "M412.23,153.09 c0.68,0,1.36-0.23,1.9-0.69c0.59-0.5,0.93-1.19,0.97-1.95c0.04-0.78-0.24-1.53-0.78-2.1c-0.55-0.59-1.29-0.92-2.07-0.93 c-0.7-0.03-1.45,0.27-1.98,0.8v0c-1.1,1.1-1.15,2.9-0.12,4C410.7,152.79,411.46,153.09,412.23,153.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128444454760198814230000016510494593659828901_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.1443,
    y1: 91.7645,
    x2: 386.6627,
    y2: 421.7692
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128444454760198814230000016510494593659828901_)"
    },
    d: "M403.1,145.06 c0.87,0,1.75-0.39,2.33-1.13c0.46-0.59,0.66-1.33,0.56-2.07c-0.11-0.77-0.53-1.46-1.19-1.94c-0.66-0.47-1.44-0.65-2.21-0.51 c-0.73,0.14-1.36,0.56-1.78,1.19c-0.85,1.3-0.55,3.07,0.67,3.94C401.95,144.89,402.52,145.06,403.1,145.06z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000145763333499662468070000000372542713612021656_",
    filterUnits: "userSpaceOnUse",
    x: 89.19,
    y: 72.48,
    width: 333.62,
    height: 367.05
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 89.19,
    y: 72.48,
    width: 333.62,
    height: 367.05,
    id: "SVGID_00000060020015369244020820000017741600471856514960_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000145763333499662468070000000372542713612021656_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000129200085987258548640000016980344190845581469_",
    filterUnits: "userSpaceOnUse",
    x: 89.19,
    y: 72.48,
    width: 333.62,
    height: 367.05
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 89.19,
    y: 72.48,
    width: 333.62,
    height: 367.05,
    id: "SVGID_00000060020015369244020820000017741600471856514960_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000172416163690684115460000003897812711891465603_",
    cx: 255.9999,
    cy: 255.9999,
    r: 205.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8738,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000060020015369244020820000017741600471856514960_)",
      fill: "url(#SVGID_00000172416163690684115460000003897812711891465603_)"
    },
    d: " M393.43,142.73L285.38,80.35c-18.18-10.5-40.58-10.5-58.76,0l-108.05,62.38c-18.18,10.5-29.38,29.89-29.38,50.89v124.77 c0,20.99,11.2,40.39,29.38,50.89l108.05,62.38c18.18,10.5,40.58,10.5,58.76,0l108.05-62.38c18.18-10.5,29.38-29.89,29.38-50.89 V193.62C422.81,172.62,411.61,153.23,393.43,142.73z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000055671592686075833250000005197593188822042248_",
    cx: 255.9999,
    cy: 255.9999,
    r: 205.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    style: {
      stopColor: "#B5B5B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8738,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000055671592686075833250000005197593188822042248_)"
    },
    d: "M393.43,142.73L285.38,80.35 c-18.18-10.5-40.58-10.5-58.76,0l-108.05,62.38c-18.18,10.5-29.38,29.89-29.38,50.89v124.77c0,20.99,11.2,40.39,29.38,50.89 l108.05,62.38c18.18,10.5,40.58,10.5,58.76,0l108.05-62.38c18.18-10.5,29.38-29.89,29.38-50.89V193.62 C422.81,172.62,411.61,153.23,393.43,142.73z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176004575238620903950000005992366912810793380_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.5837,
    y1: 135.5845,
    x2: 362.3787,
    y2: 362.3795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1828,
    style: {
      stopColor: "#007788"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2276,
    style: {
      stopColor: "#006C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3266,
    style: {
      stopColor: "#005A69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#00505D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#004C59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#00515E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7523,
    style: {
      stopColor: "#005F6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#007586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8959,
    style: {
      stopColor: "#007788"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176004575238620903950000005992366912810793380_)"
    },
    d: "M384.6,150.01L283.49,91.64 c-17.01-9.82-37.97-9.82-54.98,0L127.4,150.01c-17.01,9.82-27.49,27.97-27.49,47.62v116.75c0,19.64,10.48,37.8,27.49,47.62 l101.11,58.37c17.01,9.82,37.97,9.82,54.98,0l101.11-58.37c17.01-9.82,27.49-27.97,27.49-47.62V197.63 C412.09,177.98,401.61,159.83,384.6,150.01z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000177482574278832685200000016746717618157508767_",
    cx: 260.9841,
    cy: 258.7029,
    r: 190.7513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2142,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177482574278832685200000016746717618157508767_)"
    },
    d: "M256,430.39 c-9.97,0-19.94-2.57-28.83-7.7l-101.11-58.37c-17.78-10.27-28.83-29.4-28.83-49.94V197.63c0-20.53,11.05-39.67,28.83-49.94 l101.11-58.37c17.78-10.27,39.88-10.27,57.66,0l101.11,58.37c17.78,10.27,28.83,29.4,28.83,49.94v116.75 c0,20.53-11.05,39.67-28.83,49.94l-101.11,58.37C275.94,427.82,265.97,430.39,256,430.39z M256,86.97 c-9.04,0-18.09,2.33-26.15,6.99l-101.11,58.37c-16.13,9.31-26.15,26.67-26.15,45.3v116.75c0,18.63,10.02,35.98,26.15,45.3 l101.11,58.37c16.13,9.31,36.17,9.31,52.3,0l101.11-58.37c16.13-9.31,26.15-26.67,26.15-45.3V197.63 c0-18.63-10.02-35.98-26.15-45.3L282.15,93.96C274.09,89.3,265.04,86.97,256,86.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061464455481811655300000009220228290223091892_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.3451,
    y1: 392.5958,
    x2: 106.0107,
    y2: 413.2318,
    gradientTransform: "matrix(1 0 0 1 150.9565 -81.9565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000061464455481811655300000009220228290223091892_)"
    },
    points: "265.68,319.09 259.72,317.7  256.6,312.44 253.44,317.68 247.46,319.02 251.47,323.65 250.9,329.74 256.54,327.36 262.16,329.78 261.64,323.69  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056388759439981511900000016865790811634597251_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.3922,
    y1: 391.9168,
    x2: 127.0579,
    y2: 412.5529,
    gradientTransform: "matrix(1 0 0 1 150.9565 -81.9565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000056388759439981511900000016865790811634597251_)"
    },
    points: "284.58,329.54 280.26,330.54  278,334.35 275.71,330.56 271.38,329.59 274.29,326.24 273.87,321.82 277.96,323.55 282.03,321.79 281.65,326.21  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014618685667564855300000007517483313023163015_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.6208,
    y1: 393.2966,
    x2: 84.2865,
    y2: 413.9326,
    gradientTransform: "matrix(1 0 0 1 150.9565 -81.9565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB833E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5848,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9C977"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000014618685667564855300000007517483313023163015_)"
    },
    points: "241.76,329.54 237.44,330.54  235.18,334.35 232.89,330.56 228.57,329.59 231.47,326.24 231.06,321.82 235.14,323.55 239.21,321.79 238.83,326.21  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M158.63,193.55c-5.87,2.74-8.78,4.21-14.5,7.36c-4.92-8.94-7.37-13.41-12.29-22.36 c-4.99-9.64,1.5-18.55,10.34-22.46c12-5.32,24.47-2.63,29.18,10.44C175.68,178.53,169.76,188.41,158.63,193.55z M146.52,164.22 c-3.24,1.49-6.1,4.84-3.84,9.42c2.78,5.62,4.16,8.44,6.94,14.06c1.44-0.71,2.17-1.06,3.62-1.75c6.71-3.18,10.13-7.27,6.89-15.06 C156.96,163.27,152.88,161.3,146.52,164.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M201.38,178.29c-1.52-5.97-2.28-8.95-3.8-14.92c-1.25-4.9-2.56-6.68-6.39-5.63 c-3.34,0.92-5.32,3.92-3.79,9.04c1.7,5.68,2.55,8.53,4.26,14.21c-3.69,1.11-5.53,1.7-9.19,2.95 c-4.35-12.69-8.7-25.37-13.06-38.06c4.26-1.46,6.4-2.15,10.71-3.44c1.83,6.12,2.75,9.17,4.58,15.29 c0.15-0.04,0.22-0.07,0.37-0.11c0.22-3.11,1.87-7.42,8.46-9.1c7.93-2.03,11.65,1.54,13.22,8.9c1.59,7.47,2.39,11.21,3.99,18.69 C206.98,176.9,205.11,177.34,201.38,178.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M230.15,173.45c-9.63,1.25-16.49-3.06-18.43-12.93c-2-10.2,4.13-16.94,14.36-18.28 c10.94-1.43,17.62,4.08,18.29,14C245.06,166.63,239.2,172.27,230.15,173.45z M227.09,150.5c-3.98,0.52-6.21,3.16-5.41,8.27 c0.8,5.11,3.7,6.92,7.34,6.44c3.64-0.47,5.9-3.07,5.37-8.1C233.82,151.8,231.45,149.93,227.09,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M263.86,171.42c-9.69-0.09-15.86-5.32-16.41-15.36c-0.57-10.38,6.41-16.2,16.7-16.11 c11.01,0.1,16.87,6.48,16.15,16.4C279.56,166.72,272.97,171.51,263.86,171.42z M264.01,148.27c-4-0.04-6.57,2.27-6.49,7.44 c0.08,5.17,2.7,7.36,6.36,7.4c3.66,0.03,6.26-2.23,6.43-7.28C270.49,150.49,268.4,148.31,264.01,148.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M299.23,151.61c-2.52-0.36-3.88,0.32-4.21,2.83c-0.94,7.31-1.41,10.97-2.35,18.28 c-3.79-0.49-5.69-0.69-9.5-1.03c0.71-7.97,1.06-11.96,1.77-19.93c0.65-7.28,5.33-9.74,12.61-8.78c2.65,0.35,3.97,0.54,6.62,0.96 c-0.52,3.29-0.78,4.93-1.29,8.22C301.42,151.93,300.69,151.82,299.23,151.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M317.57,177.94c-10.91-2.58-14.14-8.6-12.43-18.63c1.69-9.9,2.53-14.86,4.22-24.76 c4.4,0.75,6.59,1.17,10.97,2.09c-1.31,6.2-1.97,9.3-3.28,15.5c0.15,0.03,0.23,0.05,0.38,0.08c1.61-2.3,5.21-5.51,12.12-3.74 c7.87,2.01,10.89,8.24,7.82,18.29C334.31,176.77,326.49,180.05,317.57,177.94z M323.08,155.45c-3.86-0.92-6.98,1.2-7.95,5.76 c-1.12,5.28,0.7,7.77,4.4,8.64c3.7,0.88,6.7-0.76,7.99-5.65C328.87,159.1,327.25,156.44,323.08,155.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M347.54,152.19c0.99-3.03,1.49-4.55,2.48-7.58c4.28,1.4,6.4,2.14,10.64,3.72 c-1.11,2.99-1.67,4.49-2.78,7.48C353.76,154.28,351.7,153.56,347.54,152.19z M337.5,182.85c3.12-9.54,6.25-19.08,9.38-28.62 c4.12,1.35,6.18,2.07,10.26,3.59c-3.5,9.41-7,18.82-10.5,28.23C343,184.69,341.17,184.05,337.5,182.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M379.08,200.9c-3.45-1.9-5.19-2.81-8.7-4.56c2.99-6,4.48-8.99,7.47-14.99c1.68-3.37,1.58-5.66-2.43-7.55 c-3.65-1.73-5.9-0.67-7.48,2.87c-2.73,6.12-4.1,9.17-6.83,15.29c-3.56-1.59-5.35-2.35-8.96-3.79c2.49-6.22,3.73-9.33,6.22-15.55 c3.63-9.08,11.2-10.78,20.67-6.31c10.13,4.79,12.44,12.03,8.11,19.91C383.92,192.1,382.3,195.03,379.08,200.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M197.3,377.84c-9.77,0-14.91-5.38-14.91-14.83c0-9.94,5.47-14.83,14.91-14.83h7.91v6.79h-6.71 c-5.05,0-8.32,1.9-8.32,8.03s3.27,8.08,8.32,8.08h6.71v6.75H197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M225.62,377.84v-12.22h-9.9v12.22h-7.45v-29.65h7.45v10.68h9.9v-10.68h7.45v29.65H225.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M250.46,378.34c-9.52,0-14.33-5.88-14.33-15.32c0-9.98,5.18-15.32,14.33-15.32 c9.23,0,14.33,5.34,14.33,15.32C264.79,372.21,260.07,378.34,250.46,378.34z M250.46,354.45c-4.31,0-6.54,2.65-6.54,8.57 c0,5.71,2.32,8.57,6.54,8.57c4.35,0,6.54-2.82,6.54-8.57C257.01,357.01,254.9,354.45,250.46,354.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M268.43,377.84v-29.65h7.45v29.65H268.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M294.19,377.84c-9.77,0-14.91-5.38-14.91-14.83c0-9.94,5.47-14.83,14.91-14.83h7.91v6.79h-6.71 c-5.05,0-8.32,1.9-8.32,8.03s3.27,8.08,8.32,8.08h6.71v6.75H294.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M319.32,377.84c-9.77,0-14.91-5.38-14.91-14.83c0-9.77,5.26-14.83,14.91-14.83h9.52v6.79h-11.1 c-3.77,0-5.26,1.95-5.55,4.64h16.65v6.46h-16.73c0.21,3.15,2.07,5.01,6.05,5.01h10.68v6.75H319.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024711017941832096910000000863972760578286223_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.0453,
    y1: 269.9255,
    x2: 315.922,
    y2: 269.9255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    style: {
      stopColor: "#E9C977"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4972,
    style: {
      stopColor: "#CB833E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024711017941832096910000000863972760578286223_)"
    },
    d: "M299.09,253.68 c-9.12-1.8-18.26,2.33-23.01,10.43c-4.51,7.69-3.62,16.65,0.24,22.49c-2.42-11.3,3.73-20.95,11.97-24.9 c8.63-4.13,20.79-2.37,27.64,7.49C314.35,262.66,308.42,255.51,299.09,253.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140718768027055524310000016767964764120753838_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.1996,
    y1: 269.9255,
    x2: 238.0763,
    y2: 269.9255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    style: {
      stopColor: "#E9C977"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4972,
    style: {
      stopColor: "#CB833E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140718768027055524310000016767964764120753838_)"
    },
    d: "M221.25,253.68 c-9.12-1.8-18.26,2.33-23.01,10.43c-4.51,7.69-3.62,16.65,0.24,22.49c-2.42-11.3,3.73-20.95,11.97-24.9 c8.63-4.13,20.79-2.37,27.64,7.49C236.5,262.66,230.57,255.51,221.25,253.68z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113326455459964446070000008156220277921140114_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.0337,
    y1: 206.0594,
    x2: 269.1087,
    y2: 206.0594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    style: {
      stopColor: "#E9C977"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4972,
    style: {
      stopColor: "#CB833E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113326455459964446070000008156220277921140114_)"
    },
    d: "M269.11,205.12 c-4.73,0.36-7.82,1.54-10.72,5.49c-1.67-4.09-4.04-7.49-8.35-9.1c2.42,0.36,4.85,0.65,6.94,2.01c0.8,0.51,1.47,1.21,2.25,1.76 c0.24,0.17,0.7,0.32,0.93,0.2C263.03,204,265.96,204.35,269.11,205.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031903130688442294130000012751622408808669101_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.2695,
    y1: 264.0891,
    x2: 329.7305,
    y2: 264.0891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    style: {
      stopColor: "#E9C977"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    style: {
      stopColor: "#E8B451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4972,
    style: {
      stopColor: "#CB833E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031903130688442294130000012751622408808669101_)"
    },
    d: "M325.75,259.31 c-2.81-5.45-5.99-8.68-7.96-10.31c-2.07-1.51-4.03-2.94-5.99-4.37c-11.2-8.18-22.4-16.36-33.62-24.52l0,0 c-1.08-0.93-2.1-1.53-3.05-1.9c-0.09-0.05-0.18-0.09-0.27-0.14c-0.01,0.01-0.02,0.02-0.03,0.03c-3.57-1.25-5.94,0.79-5.94,0.79 l-19.57,14.2l0,0c-1.86,1.35-3.72,2.7-5.57,4.07c-1.76,1.3-3.48,2.65-5.21,3.98c-0.04-0.05-0.08-0.09-0.12-0.14 c5.04-4.63,10.07-9.25,15.16-13.93c-3.27-2.52-6.45-4.94-9.6-7.39c-3.3-2.56-6.08-2.64-9.45-0.18 c-9.77,7.12-19.52,14.26-29.28,21.4c-2.93,2.14-5.85,4.29-8.79,6.44c0,0,0.01,0,0.01,0s-0.01,0-0.01,0 c-0.09,0.07-0.19,0.14-0.28,0.2c-1.27,0.96-6.59,5.22-10.16,12.16c-5.13,10.7-5.05,21.49,0.49,32.34 c2.27,4.45,5.51,8.16,9.5,11.17c7.92,5.99,16.86,8.32,26.66,6.83c10.36-1.57,18.45-6.88,24.22-15.62 c0.97-1.47,2.09-2.73,3.47-3.79c4.71-3.63,10.33-2.56,13.92,2.7c2.86,4.2,6.03,8.02,10.25,10.89c7.99,5.44,16.82,7.45,26.3,5.63 c12.88-2.47,21.86-9.99,26.54-22.21C331.09,277.93,330.3,268.43,325.75,259.31z M217.56,302.77c-7.37-0.02-13.74-2.58-19.1-7.63 c-3.12-2.94-5.19-6.61-7.1-10.38c-1.55-6.72-2.07-13.39,0.79-19.95c1.46-3.35,3.42-6.35,6.03-8.92c2.72-2.69,5.86-4.74,9.43-6.11 c3.16-1.21,6.44-1.81,9.84-1.79c15.17,0.09,27.43,12.31,27.37,27.31C244.74,290.47,232.49,302.82,217.56,302.77z M294.53,302.79 c-15.05,0.05-27.33-12.27-27.37-27.45c-0.03-15.06,12.22-27.32,27.34-27.36c15.13-0.03,27.42,12.23,27.42,27.36 C321.93,290.49,309.7,302.74,294.53,302.79z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhoorbinchoice);
export default __webpack_public_path__ + "static/media/dhoorbinchoice.49cd83fa57f36f779841deec56888ceb.svg";
export { ForwardRef as ReactComponent };